/* tslint:disable */
export const localDe = {

  'SECURITY': 'Sicherheit',
  'RIGHTS_OF_ACCESS_AND_RECTIFICATION_TEXT':
    'Sie können Kopien der von uns gespeicherten personenbezogenen Daten einsehen und verlangen, dass Ihre Daten geändert, korrigiert oder gelöscht werden. Sie können auch die Verarbeitung Ihrer Daten begrenzen, einschränken oder ablehnen.Sie können sich auf der Website anmelden, um die Informationen auf der Website zu aktualisieren.Wenn Sie uns Ihre Einwilligung erteilt haben, damit wir Ihre Daten z.B. für die Zusendung von Werbematerial verwenden können, können Sie Ihre Einwilligung direkt über den im Textkörper des Newsletters eingefügten Hypertext-Link widerrufen. Wir können uns jedoch immer auf die von Ihnen erteilte Einwilligung als Rechtsgrundlage zur Verarbeitung der Daten vor dem Widerruf Ihrer Einwilligung verlassen.Um Einwände zu erheben oder Ihre Rechte geltend zu machen, können Sie uns unter den im folgenden Artikel \'Beschwerden\' genannten Bedingungen kontaktieren.Wenn Sie mit uns Kontakt aufnehmen, werden wir Ihnen so schnell wie möglich und gegebenenfalls innerhalb von zwei Monaten antworten. Wenn Ihre Anfrage komplex ist, können sich unsere Antwortzeiten verlängern, aber wir werden uns innerhalb von maximal zwei weiteren Monaten mit Ihnen in Verbindung setzen. Die meisten Anfragen werden kostenlos bearbeitet, aber wir können Sie bitten, eine angemessene Bearbeitungsgebühr zu zahlen, wenn Sie uns z.B. um eine große Datenmenge bitten. Wir können Sie auch bitten, Ihre Identität zu verifizieren, bevor wir Ihnen Informationen zur Verfügung stellen können.',

  'CLAIMS': 'Beschwerden',
  'Go_BACKOFFICE_MESSAGE': 'Im backoffice ansehen',
  'ERROR_USER_CODE_NOT_FOUND': 'Das Token ist falsch oder abgelaufen. Bitte fordern Sie das Zurücksetzen des Passworts erneut an.',
  'ERROR_INVALID_PASSWORD': 'Das Passwort ist falsch oder identisch mit dem vorherigen.',

  'LANG_DE': 'Deutsch',
  'LANG_EN': 'Englisch',
  'LANG_ES': 'Spanisch',
  'LANG_FR': 'Französisch',
  'LANG_IT': 'Italienisch',
  'LANG_NL': 'Niederländisch',
  'MONDAY': 'Montag',
  'TUESDAY': 'Dienstag',
  'WEDNESDAY': 'Mittwoch',
  'THURSDAY': 'Donnerstag',
  'FRIDAY': 'Freitag',
  'SATURDAY': 'Samstag',
  'SUNDAY': 'Sonntag',
  'PRINT': 'Drucken',
  'CHART': 'Statistik',
  'IMPERSONATE_USER': 'Als ein anderer Benutzer einloggen',
  'LEAVE_IMPERSONATION': 'Imitation beenden',
  'MY_PROFILE': 'Mein Profil',
  'LOGOUT': 'Ausloggen',
  'RUN_AS': 'als',
  'CLOSE': 'Schließen',
  'BLOCKED': 'Blockiert',
  'AUTHORIZED': 'Autorisiert',
  'LIMITED': 'Beschränkt',
  'RESTRICTION_PLANNING': 'Zeitplan aktualisieren',
  'IMPERSONATE_DIALOG': 'Benutzerimitation Dialogfeld',
  'IMPERSONATE_DIALOG_TITLE': 'Als ein anderer Benutzer einloggen',
  'IMPERSONATE_DIALOG_EXPLAIN_P1':
    'Mit dieser Auswahl können Sie das Portal ansehen, als ob Sie als ein anderer Benutzer eingeloggt sind. Diese Auswahl ist nur für Administratoren verfügbar.',
  'IMPERSONATE_DIALOG_EXPLAIN_P2':
    'Alle unter "Imitation" durchgeführten Aktionen werden unter Ihrem Benutzerkonto ausgeführt. Die "Imitation" ist lediglich eine Darstellung dessen, was der imitierte Benutzer angezeigt bekommt.',
  'SHOW_X_ELEMENTS_START': 'Zeige',
  'SHOW_X_ELEMENTS_END': 'Elemente',
  'SEARCH': 'Suche',
  'NAME': 'Name',
  'EMAIL': 'E-Mail',
  'ROLES_GROUP': 'Rollengruppe',
  'IMPERSONATE': 'Imitation',
  'CANCEL': 'Widerrufen',
  'PAGINATION_INFO': 'Zeigt {{from}} bis {{to}} von {{filteredLength}} Elementen',
  'FILTERED_PAGINATION_INFO': 'Zeigt von {{from}} bis {{to}} {{filteredLength}} Elemente an (gefiltert aus {{totalLength}} Elementen)',
  'CLIENT_SELECTOR_PLACEHOLDER': 'Kunde wechseln...',
  'DASHBOARD': 'Dashboard',
  'USERS': 'Benutzer',
  'CREATED': 'Angelegt',
  'UPDATED': 'Aktualisiert',
  'LASTRUN': 'Gesendet am',
  'FREQUENCY': 'Frequenz',
  'DAILY': 'Täglich',
  'WEEKLY': 'Wöchentlich',
  'MONTHLY': 'Monatlich',
  'All': 'Alle',
  'SERVICES': 'Services',
  'ACTIVE': 'Aktiv',
  'DELETE': 'Löschen',
  'SEND': 'Test',
  'FILTERED': 'Gefiltert',
  'NOT_FILTERED': 'Alle',
  'EXCEL_DATA': 'Excel exportieren',
  'MY_PROFILE_TITLE': 'Mein Profil',
  'MY_PROFILE_PERSONAL_INFO': 'Meine persönliche Angaben',
  'MY_PROFILE_CHANGE_AVATAR': 'Profilbild ändern',
  'MY_PROFILE_CHANGE_PASSWORD': 'Passwort ändern',
  'MY_PROFILE_IDENTITIES': 'Meine Logins als Drittperson',
  'MY_PROFILE_USER_NAME': 'Name',
  'MY_PROFILE_USER_NAME_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_NAME_REQUIRED': 'Bitte geben Sie Ihren Namen ein.',
  'MY_PROFILE_USER_EMAIL': 'E-Mail',
  'MY_PROFILE_USER_EMAIL_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_EMAIL_REQUIRED': 'Bitte geben Sie Ihre E-Mail Adresse ein.',
  'MY_PROFILE_USER_EMAIL_INVALID': 'Ihre E-Mail Adresse ist nicht gültig.',
  'MY_PROFILE_USER_CULTURE': 'Kultur',
  'MY_PROFILE_USER_CULTURE_REQUIRED': 'Wählen Sie bitte Ihre Kultur aus.',
  'MY_PROFILE_USER_GENDER': 'Geschlecht',
  'MY_PROFILE_USER_TIMEZONE': 'Zeitzone',
  'MY_PROFILE_USER_TIMEZONE_REQUIRED': 'Wählen Sie bitte Ihre Zeitzone aus.',
  'MY_PROFILE_USER_PHONE': 'Telefon',
  'MY_PROFILE_USER_PHONE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_FAX': 'Fax',
  'MY_PROFILE_USER_FAX_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_MOBILE': 'Mobil',
  'MY_PROFILE_USER_MOBILE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_SKYPE': 'Skype',
  'MY_PROFILE_USER_SKYPE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_DEPARTMENT': 'Abteilung',
  'MY_PROFILE_USER_DEPARTMENT_PLACEHOLDER': ' ',
  'MY_PROFILE_UNSAVED_CHANGES_START': 'Sie haben die Änderungen in den folgenden Tabs nicht gespeichert:',
  'MY_PROFILE_UNSAVED_CHANGES_END': 'Möchten Sie wirklich diese Seite verlassen, ohne die Änderungen zu speichern?',
  'GENDER_UNDEFINED': ' ',
  'GENDER_WOMAN': 'Weiblich',
  'GENDER_MAN': 'Männlich',
  'SAVE_CHANGES': 'Änderung speichern',
  'SAVING_CHANGES': 'Änderungen werden gespeichert...',
  'EXTERNAL_ID_LINK': 'Verlinken',
  'EXTERNAL_ID_UNLINK': 'Verlinkung entfernen',
  'EXTERNAL_ID_GOOGLE': 'Ihr Google®-Konto verlinken.',
  'EXTERNAL_ID_MSLIVE': 'Ihr Microsoft Live®-Konto verlinken',
  'CHANGE_PASSWORD_STRENGTH': 'Passwortssicherheit',
  'PASSWORD_STRENGTH_VERY_WEAK': 'Sehr schwach',
  'PASSWORD_STRENGTH_VERY_WEAK_DESC': 'Hält Hacker für Minuten fern.',
  'PASSWORD_STRENGTH_WEAK': 'Schwach',
  'PASSWORD_STRENGTH_WEAK_DESC': 'Für Hacker innerhalb einer Woche zu entschlüsseln.',
  'PASSWORD_STRENGTH_REASONABLE': 'Angemessen',
  'PASSWORD_STRENGTH_REASONABLE_DESC': 'Für Hacker innerhalb eines Jahres zu entschlüsseln.',
  'PASSWORD_STRENGTH_STRONG': 'Stark',
  'PASSWORD_STRENGTH_STRONG_DESC': 'Schützt über ein Jahr vor Hackerangriffen.',
  'PASSWORD_STRENGTH_VERY_STRONG': 'Sehr stark',
  'PASSWORD_STRENGTH_VERY_STRONG_DESC': 'Passwort sicher.',
  'CHANGE_PASSWORD_CURRENT': 'Aktuelles Passwort',
  'CHANGE_PASSWORD_CURRENT_REQUIRED': 'Aktuelles Passwort wird benötigt.',
  'CHANGE_PASSWORD_NEW': 'Neues Passwort',
  'CHANGE_PASSWORD_NEW_REQUIRED': 'Neues Passwort wird benötigt.',
  'CHANGE_PASSWORD_NEW_MINLENGTH': 'Neues Passwort muss aus mindestens vier Symbolen bestehen.',
  'CHANGE_PASSWORD_NEW_MUST_BE_DIFFERENT': 'Neues Passwort kann nicht gleich dem aktuellen Passwort sein.',
  'CHANGE_PASSWORD_VALIDATION_ERROR_ME': 'Beim Ändern Ihres Passworts ist ein Validierungsfehler aufgetreten.',
  'CHANGE_PASSWORD_CONFIRM': 'Neues Passwort erneut eingeben',
  'CHANGE_PASSWORD_CONFIRM_MISMATCH': 'Das neue Passwort und die Bestätigung stimmen nicht überein.',
  'CHANGE_PASSWORD_SAVE': 'Passwort speichern',
  'CHANGE_PASSWORD_SAVING': 'Passwort wird gespeichert...',
  'CHANGE_AVATAR_YOURS': 'Ihr Profilbild',
  'CHANGE_AVATAR_SELECT': 'Bild auswählen',
  'CHANGE_AVATAR_CHANGE': 'Ändern',
  'CHANGE_AVATAR_REMOVE': 'Löschen',
  'CHANGE_AVATAR_SAVE': 'Bestätigen',
  'CHANGE_AVATAR_SAVING': 'Wird gespeichert...',
  'ASSIGN_GROUP_DIALOG': 'Dialogfeld Benutzer zu Benutzer Hierarchie zuweisen',
  'ASSIGN_GROUP_DIALOG_TITLE': 'Benutzer zu Rollengruppe zuweisen',
  'ASSIGN_GROUP_DIALOG_SINGLE': 'Diesen Benutzer zur Rollengruppe zuweisen.',
  'ASSIGN_GROUP_DIALOG_MULTI': 'Diese Benutzer zur Rollengruppe zuweisen.',
  'ASSIGN_GROUP_DIALOG_GROUP': 'Rollengruppe:',
  'ASSIGN_GROUP_DIALOG_NOSELECTION': '(Hierarchie auswählen)',
  'ASSIGN_GROUP_DIALOG_ACCEPT': 'Zuweisen',
  'AUTH0_INFO_TITLE': 'Verbindungsinfo',
  'AUTH0_INFO_HISTORY': 'Verlauf',
  'AUTH0_INFO_MAP': 'Standorte',
  'AUTH0_LOGS_DURATION': 'Max. Log-Speicherung: 10 Tage.',
  'AUTH0_LOGS_EVENT': 'Event',
  'AUTH0_LOGS_WHEN': 'Wenn',
  'AUTH0_LOGS_APP': 'App',
  'AUTH0_LOGS_IDP': 'Anbieter Identität',
  'AUTH0_LOGS_IP': 'IP-Adresse',
  'AUTH0_LOGS_FROM': 'Von',
  'AUTH0_MAP_SUCCESS_LOGIN': 'Erfolgreich eingeloggt',
  'CONFIRM_DELETE_USERS_DIALOG': 'Benutzer löschen',
  'CONFIRM_DELETE_USERS_DIALOG_TITLE': 'Löschen bestätigt',
  'CONFIRM_DELETE_USERS_DIALOG_SINGLE': 'Möchten Sie wirklich diesen Benutzer löschen?',
  'CONFIRM_DELETE_USERS_DIALOG_MULTI': 'Möchten Sie wirklich diese Benutzer löschen?',
  'CONFIRM_DELETE_USERS_DIALOG_ACCEPT': 'Löschen',
  'CREATE_USER_DIALOG': 'Neuen Benutzer erstellen',
  'CREATE_USER_DIALOG_TITLE': 'Benutzer erstellen',
  'CREATE_USER_DIALOG_ACCEPT': 'Erstellen',
  'CREATE_USER_DIALOG_NAME': 'Name',
  'CREATE_USER_DIALOG_NAME_PLACEHOLDER': ' ',
  'CREATE_USER_DIALOG_NAME_REQUIRED': 'Benutzername wird benötigt.',
  'CREATE_USER_DIALOG_EMAIL': 'E-Mail',
  'CREATE_USER_DIALOG_EMAIL_PLACEHOLDER': ' ',
  'CREATE_USER_DIALOG_EMAIL_REQUIRED': 'Die E-Mail Adresse wird benötigt.',
  'CREATE_USER_DIALOG_EMAIL_INVALID': 'Die E-Mail Adresse ist nicht gültig.',
  'CREATE_USER_DIALOG_ROLES_GROUP': 'Rollengruppe',
  'CREATE_USER_DIALOG_ROLES_GROUP_NONE': ' ',
  'CREATE_USER_DIALOG_ROLES_GROUP_REQUIRED': 'Die Rollengruppe wird benötigt.',
  'CREATE_USER_DIALOG_OFFICE': 'Büros',
  'CREATE_USER_DUPLICATE': 'Benutzer ist schon angelegt. Sie wurden zum existierenden Benutzer weitergeleitet.',
  'OFFICE_NONE': ' ',
  'OFFICE_BE': 'Belgien',
  'OFFICE_FR': 'Frankreich',
  'OFFICE_ES': 'Spanien',
  'OFFICE_DE': 'Deutschland',
  'OFFICE_CN': 'China',
  'OFFICE_IT': 'MCube Italia',
  'EDIT_USER_NAME': 'Name',
  'EDIT_USER_NAME_PLACEHOLDER': ' ',
  'EDIT_USER_NAME_REQUIRED': 'Benutzername wird benötigt.',
  'EDIT_USER_EMAIL': 'E-Mail',
  'EDIT_USER_EMAIL_PLACEHOLDER': ' ',
  'EDIT_USER_EMAIL_REQUIRED': 'Die E-Mail Adresse wird benötigt.',
  'EDIT_USER_EMAIL_INVALID': 'Die E-Mail Adresse ist nicht gültig.',
  'EDIT_USER_ROLES_GROUP': 'Rollengruppe',
  'EDIT_USER_ROLES_GROUP_NONE': ' ',
  'EDIT_USER_ROLES_GROUP_REQUIRED': 'Die Rollengruppe wird benötigt.',
  'EDIT_USER_OFFICE': 'Büro',
  'EDIT_USER_CULTURE': 'Kultur',
  'EDIT_USER_CULTURE_REQUIRED': 'Wählen Sie bitte Ihre Kultur aus.',
  'EDIT_USER_GENDER': 'Geschlecht',
  'EDIT_USER_TIMEZONE': 'Zeitzone',
  'EDIT_USER_TIMEZONE_REQUIRED': 'Zeitzone wird benötigt.',
  'EDIT_USER_PHONE': 'Telefon',
  'EDIT_USER_PHONE_PLACEHOLDER': ' ',
  'EDIT_USER_FAX': 'Fax',
  'EDIT_USER_FAX_PLACEHOLDER': ' ',
  'EDIT_USER_MOBILE': 'Mobil',
  'EDIT_USER_MOBILE_PLACEHOLDER': ' ',
  'EDIT_USER_SKYPE': 'Skype',
  'EDIT_USER_SKYPE_PLACEHOLDER': ' ',
  'EDIT_USER_DEPARTMENT': 'Abteilung',
  'EDIT_USER_DEPARTMENT_PLACEHOLDER': ' ',
  'IMPORT_USERS_DIALOG': 'Dialogfeld Benutzer von anderen Kunden importieren',
  'IMPORT_USERS_DIALOG_TITLE': 'Benutzer importieren',
  'IMPORT_USERS_DIALOG_CLIENT': 'Kunde:',
  'IMPORT_USERS_DIALOG_CLIENT_NONE': '(Kunde auswählen)',
  'IMPORT_USERS_DIALOG_USER': 'Benutzer:',
  'IMPORT_USERS_DIALOG_ROLES_GROUP': 'Rollengruppe:',
  'IMPORT_USERS_DIALOG_ROLES_GROUP_NONE': '(Hierarchie auswählen)',
  'IMPORT_USERS_DIALOG_ACCEPT': 'Importieren',
  'USERS_LIST_TITLE': 'Benutzer',
  'USERS_LIST_CREATE': 'Erstellen',
  'USERS_LIST_IMPORT': 'Importieren',
  'USERS_LIST_FILTER': 'Filtern',
  'EXPANDER_TITLE': 'Maximieren/Minimieren',
  'USERS_LIST_FILTER_NAME': 'Name',
  'USERS_LIST_FILTER_EMAIL': 'E-Mail',
  'USERS_LIST_FILTER_ACTIVE': 'Aktiv',
  'USERS_LIST_FILTER_ACTIVE_ALL': ' ',
  'YES': 'Ja',
  'NO': 'Nein',
  'USERS_LIST_FILTER_ROLES_GROUP': 'Rollengruppe',
  'USERS_LIST_FILTER_ROLES_GROUP_ALL': ' ',
  'USERS_LIST_FILTER_SEARCH': 'Suche',
  'USERS_LIST_FILTER_RESET': 'Zurücksetzen',
  'USERS_LIST_SELECT_PAGE': 'Seite auswählen',
  'USERS_LIST_UNSELECT_PAGE': 'Seite abwählen',
  'USERS_LIST_ACTIONS': 'Aktionen',
  'USERS_LIST_TOGGLE_STATUS': 'Blockieren',
  'USERS_LIST_ASSIGN_ROLES_GROUP': 'Rollengruppe zuweisen',
  'USERS_LIST_LINK_AUDIO_PLAYERS': 'Zu(m) Audio Player(n) verlinken',
  'USERS_LIST_UNLINK_AUDIO_PLAYERS': 'Verlinkung vom(n) Audio Player(n) aufheben',
  'USERS_LIST_LINK_VIDEO_PLAYERS': 'Zu(m) Video Player(n) verlinken',
  'USERS_LIST_UNLINK_VIDEO_PLAYERS': 'Verlinkung vom(n) Video Player(n) aufheben',
  'USERS_LIST_DELETE': 'Löschen',
  'USERS_LIST_COLUMN_AVATAR': 'Profilbild',
  'USERS_LIST_COLUMN_NAME': 'Name',
  'USERS_LIST_COLUMN_EMAIL': 'E-Mail',
  'USERS_LIST_COLUMN_ROLES_GROUP': 'Rollengruppe',
  'USERS_LIST_COLUMN_NUMBER_AUDIO': '# Audio',
  'USERS_LIST_COLUMN_NUMBER_VIDEO': '# Video',
  'USERS_LIST_COLUMN_STATUS': 'Status',
  'USER_NOT_FOUND': 'Der Benutzer existiert nicht mehr.',
  'USER_SIDEBAR_BLOCK': 'Benutzer blockieren',
  'USER_SIDEBAR_UNBLOCK': 'Benutzer entsperren',
  'USER_SIDEBAR_DELETE': 'Benutzer löschen',
  'USER_SIDEBAR_RESET_PASSWORD': 'Passwort zurücksetzen',
  'USER_SIDEBAR_USER_INFO': 'Benutzer Info',
  'USER_SIDEBAR_SUBSCRIPTION_INFO': 'Verwaltete Player',
  'USER_SIDEBAR_CONNECTION_INFO': 'Letzte Logins',
  'USER_SUBSCRIPTIONS_ASSIGN_ALL': 'Alle Player zuweisen (einschließlich die, die später angelegt werden).',
  'USER_SUBSCRIPTIONS_IMPORT': 'Von einem anderen Benutzer importieren',
  'USER_SUBSCRIPTIONS_ASSIGNED': 'Zugewiesene Player',
  'USER_SUBSCRIPTIONS_ASSIGNED_TEXT': 'Einen Player aus der Liste der nicht zugewiesenen Player ziehen, um ihn dem Benutzer zuzuweisen.',
  'USER_SUBSCRIPTIONS_ASSIGNED_FILTER': 'Zugewiesene Player filtern',
  'USER_SUBSCRIPTIONS_ASSIGNED_EMPTY': 'Benutzer hat Zugriff auf keine Player.',
  'USER_SUBSCRIPTIONS_ASSIGNED_TOGGLE': 'Zuweisung von allen Playern entfernen',
  'USER_SUBSCRIPTIONS_UNASSIGNED': 'Nicht zugewiesene Player',
  'USER_SUBSCRIPTIONS_UNASSIGNED_TEXT': 'Einen Player aus der Liste der zugewiesenen Player ziehen, um ihn vom Benutzer zu entfernen.',
  'USER_SUBSCRIPTIONS_UNASSIGNED_FILTER': 'Nicht zugewiesene Player filtern',
  'USER_SUBSCRIPTIONS_UNASSIGNED_EMPTY': 'Benutzer hat Zugriff auf alle Player.',
  'USER_SUBSCRIPTIONS_UNASSIGNED_TOGGLE': 'Alle Player zuweisen',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG': 'Die Player von einem anderen Benutzer importieren',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_TITLE': 'Die Player von einem anderen Benutzer importieren',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER': 'Wählen Sie den Benutzer aus, von dem der Player importiert werden soll',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER_NONE': '-- Benutzer auswählen --',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_ACCEPT': 'Importieren',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG': 'Benutzer zu {{type}} Playern verlinken.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG': 'Benutzer von {{type}} Playern entfernen.',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_TITLE': 'Zu {{type}} Player verlinken',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_TITLE': 'Von {{type}} Player entfernen',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_SINGLE': 'Wählen Sie den/die Player aus, den/die Sie mit diesem Benutzer verlinken möchten.',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_MULTI': 'Wählen Sie den/die Player aus, den/die Sie mit diesen Benutzern verlinken möchten.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_SINGLE': 'Wählen Sie den/die Player aus, den/die Sie von diesem Benutzer entfernen möchten.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_MULTI': 'Wählen Sie den/die Player aus, den/die Sie von diesen Benutzern entfernen möchten.',
  'USERS_UN_LINK_SUBSCRIPTIONS_USERS': 'Benutzer',
  'USERS_UN_LINK_SUBSCRIPTIONS_PLAYERS': 'Player',
  'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_ALL': 'Alle auswählen',
  'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_NONE': 'Keine auswählen',
  'USERS_UN_LINK_SUBSCRIPTIONS_LINK': 'Verlinken',
  'USERS_UN_LINK_SUBSCRIPTIONS_UNLINK': 'Entfernen',
  'USER_INFO_TITLE': 'Benutzer Info',
  'USER_INFO_PERSONAL_INFO': 'Persönliche Info',
  'USER_INFO_AVATAR': 'Profilbild ändern',
  'USER_INFO_AUDIO_PLAYERS': 'Audio Player',
  'USER_INFO_VIDEO_PLAYERS': 'Video Player',
  'USER_INFO_UNSAVED_CHANGES_START': 'Sie haben Änderungen in den folgenden Tabs nicht gespeichert:',
  'USER_INFO_UNSAVED_CHANGES_END': 'Möchten Sie wirklich diese Seite verlassen, ohne die Änderungen zu speichern?',
  'TOAST_ERROR_TITLE': 'Fehler',
  'TOAST_SUCCESS_TITLE': 'Erfolg',
  'TOAST_INFO_TITLE': 'Information',
  'TOAST_WARNING_TITLE': 'Warnung',
  'TOAST_ACCESS_DENIED_TITLE': 'Zugriff abgelehnt',
  'GROUP_ROLES_LOAD_ERROR': 'Beim Abrufen der Rollengruppen für den aktuellen Kunden ist ein Fehler aufgetreten.',
  'GROUP_ROLES_TEMPLATES_LOAD_ERROR': 'Beim Abrufen der Rollengruppen-Vorlagen für den aktuellen Kunden ist ein Fehler aufgetreten.',
  'CULTURES_LOAD_ERROR': 'Beim Abrufen der verfügbaren Kulturen ist ein Fehler aufgetreten.',
  'OFFICES_LOAD_ERROR': 'Beim Laden der verfügbaren Büros ist ein Fehler aufgetreten.',
  'MY_CLIENTS_LOAD_ERROR': 'Die Liste der Kunden, auf die Sie Zugriff haben, kann nicht geladen werden.',
  'SUBSCRIPTIONS_LIST_LOAD_AUDIO_ERROR': 'Beim Abrufen der Audioplayer für den aktuellen Kunden ist ein Fehler aufgetreten.',
  'SUBSCRIPTIONS_LIST_LOAD_VIDEO_ERROR': 'Beim Abrufen der Videoplayer für den aktuellen Kunden ist ein Fehler aufgetreten.',
  'TIMEZONES_LOAD_ERROR': 'Beim Laden der verfügbaren Zeitzonen ist ein Fehler aufgetreten.',
  'USER_LOAD_ERROR_ME': 'Beim Laden Ihres Profils ist ein Fehler aufgetreten.',
  'USER_LOAD_ERROR': 'Beim Laden der Benutzerdetails ist ein Fehler aufgetreten.',
  'USER_SAVE_SUCCESS_ME': 'Ihr Profil wurde erfolgreich gespeichert.',
  'USER_SAVE_SUCCESS': 'Die Benutzerdaten wurden erfolgreich gespeichert.',
  'USER_SAVE_ERROR_ME': 'Beim Speichern Ihres Profils ist <ein Fehler aufgetreten.',
  'USER_SAVE_VALIDATION_ERROR_ME': 'Beim Speichern Ihres Profils ist ein Validierungsfehler aufgetreten.',
  'USER_SAVE_ERROR': 'Beim Speichern der Benutzerdetails ist ein Fehler aufgetreten.',
  'USER_SAVE_VALIDATION_ERROR': 'Beim Speichern der Benutzerdetails ist ein Validierungsfehler aufgetreten.',
  'USER_CHANGE_AVATAR_SUCCESS_ME': 'Ihr Profilbild wurde erfolgreich gespeichert.',
  'USER_CHANGE_AVATAR_SUCCESS': 'Das Benutzerprofilbild wurde erfolgreich geändert.',
  'USER_CHANGE_AVATAR_ERROR_ME': 'Beim Speichern des Profilbilds ist ein Fehler aufgetreten.',
  'USER_CHANGE_AVATAR_ERROR': 'Beim Speichern des Profilbilds ist ein Fehler aufgetreten.',
  'USER_CHANGE_PASSWORD_SUCCESS': 'Das Passwort wurde erfolgreich geändert.',
  'USER_CHANGE_PASSWORD_ERROR': 'Beim Speichern des Passworts ist ein Fehler aufgetreten.',
  'USER_RESET_PASSWORD_SUCCESS': 'Das Benutzerpasswort wurde erfolgreich geändert.',
  'USER_RESET_PASSWORD_ERROR': 'Bei der Änderung des Passworts ist ein Fehler aufgetreten.',
  'USER_TOGGLE_ACTIVE_SUCCESS': 'Der Benutzer wurde erfolgreich aktualisiert',
  'USER_TOGGLE_ACTIVE_ERROR': 'Beim Aktualisieren des Benutzers ist ein Fehler aufgetreten.',
  'USER_REMOVE_SUCCESS': 'Der Benutzer wurde erfolgreich vom Kunden gelöscht.',
  'USER_REMOVE_ERROR': 'Beim Löschen des Benutzers ist ein Fehler aufgetreten.',
  'USER_REMOVE_SELF_ERROR': 'Sie können Ihr eigenes Benutzerprofil nicht löschen',
  'USER_LOAD_AUDIO_SUBSCRIPTIONS_ERROR': 'Beim Laden der Audioplayer des Benutzers ist ein Fehler aufgetreten.',
  'USER_LOAD_VIDEO_SUBSCRIPTIONS_ERROR': 'Beim Laden der Videoplayer des Benutzers ist ein Fehler aufgetreten..',
  'USER_UPDATE_AUDIO_SUBSCRIPTIONS_SUCCESS': 'Die Audioplayer des Benutzers wurden erfolgreich aktualisiert.',
  'USER_UPDATE_AUDIO_SUBSCRIPTIONS_ERROR': 'Beim Aktualisieren der Audioplayer des Benutzers ist ein Fehler aufgetreten.',
  'USER_UPDATE_VIDEO_SUBSCRIPTIONS_SUCCESS': 'Die Videoplayer des Benutzers wurden erfolgreich aktualisiert.',
  'USER_UPDATE_VIDEO_SUBSCRIPTIONS_ERROR': 'Beim Aktualisieren der Videoplayer des Benutzers ist ein Fehler aufgetreten.',
  'USER_IMPORT_AUDIO_SUBSCRIPTIONS_SUCCESS': 'Die Audioplayer wurden erfolgreich importiert.',
  'USER_IMPORT_AUDIO_SUBSCRIPTIONS_ERROR': 'Beim Importieren von Audioplayer von einem anderen Benutzer ist ein Fehler aufgetreten.',
  'USER_IMPORT_VIDEO_SUBSCRIPTIONS_SUCCESS': 'Die Videoplayer wurden erfolgreich importiert.',
  'USER_IMPORT_VIDEO_SUBSCRIPTIONS_ERROR': 'Beim Importieren von Videoplayer von einem anderen Benutzer ist ein Fehler aufgetreten.',
  'USER_CONTEXT_IMPERSONATE_ACCESS_DENIED': 'Sie können sich nicht als ein anderer Benutzer darstellen.',
  'USER_CONTEXT_IMPERSONATE_SUCCESS':
    'Sie geben sich jetzt als {{username}} aus für die nächsten {{duration}} Minuten oder bis Sie den Identitätswechsel manuell verlassen.',
  'USER_CONTEXT_IMPERSONATE_ERROR': 'Beim Identitätswechsel zu {{username}} ist ein Fehler aufgetreten.',
  'USER_CONTEXT_GET_ROLES_ERROR': 'Ihre Rollen können nicht abgerufen werden. Bitte wenden Sie sich an Ihren Administrator.',
  'USER_CONTEXT_GET_IMPERSONABLE_ERROR':
    'Ausgegebene Benutzer für Kunde  "{{clientName}}" können nicht abgerufen werden. Bitte kontaktieren Sie Ihren Administrator.',
  'USERS_LOAD_ERROR': 'Beim Abrufen der Benutzer ist ein Fehler aufgetreten.',
  'USERS_LOAD_BAD_REQUEST_ERROR': 'Im Suchfilter ist ein Fehler aufgetreten.',
  'USERS_DELETE_ERROR': 'Beim Löschen der ausgewählten Benutzer ist mindestens ein Fehler aufgetreten.',
  'USERS_DELETE_SELF_ERROR': 'Sie können Ihr eigenes Benutzerprofil nicht löschen.',
  'USERS_DELETE_SUCCESS': 'Die ausgewählten Benutzer wurden gelöscht.',
  'USERS_REFRESH_ERROR': 'Beim Aktualisieren der Benutzer ist ein Fehler aufgetreten.',
  'USERS_IMPORT_ERROR': 'Beim Importieren der Benutzer ist ein Fehler aufgetreten',
  'USERS_IMPORT_BAD_REQUEST_ERROR': 'Beim Importieren der Benutzer ist ein Validierungsfehler aufgetreten.',
  'USERS_IMPORT_SUCCESS': 'Der/die Benutzer wurde(n) erfolgreich gelöscht.',
  'USERS_CREATE_SUCCESS': 'Der/die Benutzer wurde(n) erfolgreich erstellt.',
  'USERS_CREATE_ERROR': 'Beim Anlegen eines neuen Benutzers ist ein Fehler aufgetreten.',
  'USERS_CREATE_BAD_REQUEST_ERROR': 'Beim Anlegen eines neuen Benutzers ist ein Validierungsfehler aufgetreten.',
  'USERS_PATCH_SUCCESS': 'Der ausgewählte Benutzer wurde erfolgreich aktualisiert.',
  'USERS_PATCH_ERROR': 'Beim Aktualisieren des ausgewälten Benutzers ist ein Fehler aufgetreten.',
  'USERS_UN_LINK_SUBSCRIPTIONS_SUCCESS': 'Die ausgewählten Benutzer wurden erfolgreich aktualisiert.',
  'USERS_UN_LINK_SUBSCRIPTIONS_ERROR': 'Beim Aktualisieren der ausgewählten Benutzer ist ein Fehler aufgetreten.',
  'AUTH_UNLINK_SUCCESS': 'Die Verknüpfung zu Ihrem Konto wurde erfolgreich aufgehoben.',
  'AUTH_UNLINK_ERROR': 'Beim Aufheben der Verknüpfung zu Ihrem Konto ist ein Fehler aufgetreten.',
  'AUTH_GET_USER_INFO_ERROR': 'Beim Abrufen Ihrer Benutzerinformationen vom Authentifizierungsanbieter ist ein Fehler aufgetreten: [{{code}}]] {{description}}',
  'AUTH_UPDATE_PROFILE_ERROR': 'Beim Versuch, Ihr Profil zu aktualisieren, ist ein Fehler aufgetreten.',
  'AUTH_LOGS_LOAD_ERROR': 'Beim Abrufen der Authentifizierungsprotokolle für den Benutzer ist ein Fehler aufgetreten.',
  'AUTH_LINK_ERROR': 'Beim Verknüpfen Ihres Kontos mit dem Social Media Konto ist ein Fehler aufgetreten.',
  'AUTH_LINK_ERROR_DETAILS': 'Beim Verknüpfen Ihres Kontos mit dem Social Media Konto ist ein Fehler aufgetreten: [{{code}}] {{description}}',
  'ERROR_PAGE_NOT_FOUND': '404',
  'ERROR_PAGE_NOT_FOUND_TITLE': 'Houston, wir haben ein Problem.',
  'ERROR_PAGE_NOT_FOUND_PARA': 'Die gesuchte Seite existiert nicht.',
  'ERROR_PAGE_RETURN_HOME': 'Zur Startseite zurückkehren',
  'ERROR_PAGE_ACCESS_DENIED': '403',
  'ERROR_PAGE_ACCESS_DENIED_TITLE': 'Houston, Du hast ein Problem.',
  'ERROR_PAGE_ACCESS_DENIED_PARA': 'Sie haben keinen Zugriff auf diese Seite.',
  'AUTH_LOGIN_GENERIC_ERROR': 'Beim Versuch, Sie zu verbinden, ist ein Fehler aufgetreten. Bitte wenden Sie sich an Ihren Administrator.',
  'AUTH_LOGIN_WRONG_CREDENTIALS': 'Falsche(s) E-Mail / Passwort.',
  'AUTH_LOGIN_BLOCKED': 'Ihr Benutzerkonto ist blockiert. Bitte wenden Sie sich an Ihren Administrator.',
  'AUTH_LOGIN_LEAKED': 'Dieses Login wurde blockiert, da Ihr Passwort auf einer anderen Website erkannt wurde. Bitte wenden Sie sich an Ihren Administrator.',
  'AUTH_LOGIN_SOCIAL_FIRST': 'Sie können sich nicht mit einem Social Media Konto anmelden, da dies nicht mit einem vorhandenen lokalen Konto verknüpft ist.',
  'AUTH_LOGIN_ACCESS_DENIED': 'Zugriff ist verweigert. Bitte wenden Sie sich an Ihren Administrator.',
  'AUTH_LOGIN_INVALID_TOKEN': 'Ungültiges Token:',
  'AUTH_LOGIN_AUTO_TITLE': 'Bitte warten Sie...',
  'AUTH_LOST_PASSWORD_TITLE': 'Passwort vergessen?',
  'AUTH_RENEW_PASSWORD_TITLE': 'Der Link ist abgelaufen, bitte fragen Sie diesen erneut an.',
  'AUTH_LOST_PASSWORD_PARA': 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
  'AUTH_LOST_PASSWORD_ERROR': 'Beim Senden Ihrer Anfrage ist ein Fehler aufgetreten.',
  'AUTH_LOST_PASSWORD_SUCCESS': 'Eine E-Mail mit einem Link zum Zurücksetzen des Passworts wurde an Sie gesendet.',
  'AUTH_GOTO_LOGIN_PAGE': 'Klicken Sie hier, um zur Anmeldeseite zu gelangen',
  'AUTH_LOST_PASSWORD_EMAIL': 'E-Mail',
  'AUTH_LOST_PASSWORD_EMAIL_REQUIRED': 'E-Mail Adresse wird benötigt.',
  'AUTH_LOST_PASSWORD_EMAIL_INVALID': 'Die E-Mail Adresse ist nicht gültig.',
  'AUTH_LOST_PASSWORD_BACK': 'Zurück',
  'AUTH_LOST_PASSWORD_SUBMIT': 'Bestätigen',
  'AUTH_LOST_PASSWORD_SUBMITTING': 'Wird geprüft...',
  'AUTH_RESET_PASSWORD_TITLE': 'Passwort zurücksetzen',
  'AUTH_RESET_PASSWORD_PARA': 'Geben Sie Ihr neues Passwort ein und bestätigen Sie es.',
  'AUTH_RESET_PASSWORD_ERROR': 'Beim Senden Ihres neuen Passworts ist ein Fehler aufgetreten.',
  'AUTH_RESET_PASSWORD_SUCCESS': 'Ihr Passwort wurde zurückgesetzt.',
  'AUTH_RESET_PASSWORD_NEW': 'Neues Passwort',
  'AUTH_RESET_PASSWORD_NEW_REQUIRED': 'Neues Passwort wird benötigt.',
  'AUTH_RESET_PASSWORD_NEW_MINLENGTH': 'Neues Passwort muss aus mindestens 4 Symbolen bestehen.',
  'AUTH_RESET_PASSWORD_CONFIRM': 'Passwortbestätigung',
  'AUTH_RESET_PASSWORD_CONFIRM_MISMATCH': 'Das neue Passwort und seine Bestätigung stimmen nicht überein.',
  'AUTH_RESET_PASSWORD_SUBMIT': 'Bestätigen',
  'AUTH_RESET_PASSWORD_SUBMITTING': 'Wird geprüft...',
  'PLAYERS': 'Player',
  'PAGE_SIZE_ALL': 'Alle',
  'ALL_SUBSCRIPTIONS': 'Alle',
  'PLAYERS_LIST_TITLE': 'Player',
  'ALERT_PLAYERS_LIST_TITLE': 'Automatische E-Mail-Benachrichtigungen über Offline-Player',
  'ALERT_PLAYERS_TEST_MESSAGE_SEND': 'Der Alarmtest für Offline-Player wird per E-Mail gesendet.',
  'PLAYER_REPORT_OFFLINE': 'Bericht Player offline ',
  'PLAYERS_DECONNECTED_CREATE': 'Alarm E-Mail (Player offline)',
  'PLAYERS_EXPORT_TO_EXCEL': 'Datei',
  'PLAYERS_EXPORT_TO_EXCEL_BY_EMAIL': 'E-Mail',
  'PLAYER_TYPE': 'Service',
  'PLAYER_SITE': 'Subscription',
  'PLAYER_ID': 'Player ID',
  'PLAYER_STATUS': 'Status',
  'PLAYER_DEFAULT': 'Standard',
  'PLAYER_PRODUCT': 'Produkt',
  'PLAYER_COUNTRY': 'Land',
  'PLAYER_LAST_CONNECTION': 'Letzte Verbindung',
  'PLAYER_EXTERNAL_ID': 'Externe ID',
  'PLAYER_ONLINE': 'Online',
  'PLAYER_OFFLINE': 'Offline',
  'PLAYER_UPDATE_FAILED': 'Update nicht erfolgreich',
  'PLAYER_UPDATE_INCOMPLETE': 'Update unvollständig',
  'PLAYER_UPDATE_SUCCESS': 'Update erfolgreich',
  'PLAYER_DELIVERED': 'Zugestellt',
  'PLAYER_NOT_DELIVERED': 'Wird geliefert',
  'PLAYERS_LIST_FILTER': 'Filtern',
  'PLAYERS_LIST_FILTER_SITE': 'Site',
  'PLAYERS_LIST_FILTER_PLAYER_ID': 'Player ID',
  'PLAYERS_LIST_FILTER_PLAYER_TYPE': 'Service',
  'PLAYERS_LIST_FILTER_SERVICE_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_SERVICE_AUDIO': 'Nur Audio Player',
  'PLAYERS_LIST_FILTER_SERVICE_VIDEO': 'Nur Video Player',
  'PLAYERS_LIST_FILTER_PRODUCT': 'Produkt',
  'PLAYERS_LIST_FILTER_DEFAULT': 'Standard?',
  'PLAYERS_LIST_FILTER_DEFAULT_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_DEFAULT_YES': 'Nur Standard-Player',
  'PLAYERS_LIST_FILTER_DEFAULT_NO': 'Andere Player',
  'PLAYERS_LIST_FILTER_SEARCH': 'Suche',
  'PLAYERS_LIST_FILTER_RESET': 'Zurücksetzen',
  'COUNTRIES_LOAD_ERROR': 'Beim Laden der verfügbaren Länder ist ein Fehler aufgetreten.',
  'PLAYERS_LOAD_ERROR': 'Beim Laden der Player ist ein Fehler aufgetreten.',
  'PLAYERS_LOAD_BAD_REQUEST_ERROR': 'Beim Laden der Player ist ein Validierungsfehler aufgetreten.',
  'PLAYERS_LIST_FILTER_COUNTRY_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_COUNTRY': 'Land',
  'PLAYERS_LIST_FILTER_UPDATED': 'Aktualisiert?',
  'PLAYERS_LIST_FILTER_UPDATED_YES': 'Aktualisierte Player',
  'PLAYERS_LIST_FILTER_UPDATED_INCOMPLETE': 'Unvollständig aktualisierte Player',
  'PLAYERS_LIST_FILTER_UPDATED_FAILED': 'Player ohne erfolgreiches Update',
  'PLAYERS_LIST_FILTER_UPDATED_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_ONLINE': 'Online?',
  'PLAYERS_LIST_FILTER_ONLINE_YES': 'Online Player',
  'PLAYERS_LIST_FILTER_ONLINE_NO': 'Offline Player',
  'PLAYERS_LIST_FILTER_ONLINE_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_EXTERNAL_ID': 'Externe ID',
  'PLAYERS_LIST_QUICK_SEARCH': 'Schnelle Suche mit Player ID oder Standort',
  'PRODUCTS_LOAD_ERROR': 'Beim Laden der verfügbaren Produkte ist ein Fehler aufgetreten..',
  'PLAYERS_LIST_FILTER_PRODUCT_DEFAULT': ' ',
  'PLAYER_INFO_TITLE': 'Player Info',
  'PLAYER_GENERAL': 'Allgemein',
  'PLAYER_LOCATION': 'Standort',
  'PLAYER_SHIPPING': 'Versandinfo',
  'PLAYER_CONNECTIVITY': 'Verbindung',
  'PLAYER_MODEL': 'Modell',
  'PLAYER_LAST_PLAY': 'Letzte Ausspielung',
  'PLAYER_DEVICE_ID': 'Geräte-ID',
  'PLAYER_TIMEZONE': 'Zeitzone',
  'PLAYER_SITE_STATUS': 'Player Status',
  'PLAYER_IP_ADDRESS': 'Lokale IP Adresse',
  'PLAYER_FIRMWARE': 'Firmware',
  'PLAYER_SERIAL_NUMBER': 'Ordnungsnummer',
  'PLAYER_DELIVERY_STATUS': 'Lieferstatus',
  'PLAYER_UPDATED': 'Update erfolgreich',
  'PLAYER_MAC_ADDRESS': 'MAC Adresse',
  'PLAYER_WIFI_MAC_ADDRESS': 'Wifi MAC-Adresse',
  'PLAYER_LAST_UPDATE': 'Letztes Update',
  'PLAYER_LAST_DOWNLOAD': 'Letzter Download',
  'PLAYER_LAST_CONFIG': 'Letzte Konfiguration',
  'PLAYER_LAST_TASK': 'Letzter Befehl',
  'PLAYER_LAST_MONITORING': 'Letztes Monitoring',
  'PLAYER_PUBLIC_IP': 'Öffentliche IP Adresse',
  'PLAYER_SITE_STATUS_STOP': 'Beendet',
  'PLAYER_SITE_STATUS_TO_OFF': 'To Off',
  'PLAYER_SITE_STATUS_OFF': 'Off',
  'PLAYER_SITE_STATUS_DEMO': 'Demo',
  'PLAYER_SITE_STATUS_EXPLOIT': 'Exploit',
  'PLAYER_GENERAL_INFO': 'Allgemeine Info',
  'PLAYER_MONITORING_INFO': 'Monitoring Info',
  'PLAYER_INVENTORY': 'Speicherinhalt',
  'OPENING_HOURS': 'Öffnungszeiten',
  'PLAYER_INVENTORY_PAGE_TITLE': 'Portal | Player | Speicher',
  'REFRESH_PLAYER': 'Klicken Sie hier, um die Playerinformationen neu zu laden',
  'GEOCODE_OVER_QUERY_LIMIT': 'Es wurden zu viele Geokodierungsanforderungen an die Google Maps-API gestellt.',
  'GEOCODE_GENERIC_ERROR': 'Beim Geokodieren der Adresse mit der Google Maps-API ist ein Fehler aufgetreten.',
  'GEOCODE_ZERO_RESULTS': 'Die Adresse konnte mit der Google Maps-API nicht geokodiert werden.',
  'PLAYERS_DOWNLOAD_CSV_ERROR': 'Beim Herunterladen aller Player als CSV ist ein Fehler aufgetreten.',
  'PLAYERS_DOWNLOAD_CSV_START': 'Die Excel-Datei mit allen Informationen zu den Playern wird derzeit erstellt und in Kürze heruntergeladen.',
  'PLAYERS_SEND_BY_EMAIL_CSV_ERROR': 'Beim Versenden aller Player als CSV per E-Mail ist ein Fehler aufgetreten.',
  'PLAYERS_SEND_BY_EMAIL_CSV_START': 'Die Excel-Datei mit allen Playerinformationen wird derzeit per E-Mail gesendet.',
  'PLAYER_INFO_ERROR': 'Beim Laden der Player-Informationen ist ein Fehler aufgetreten.',
  'PLAYER_SHIPPING_ERROR': 'Beim Laden der Versandinformationen für den Player ist ein Fehler aufgetreten.',
  'PLAYER_SHIPPING_TYPE': 'Typ',
  'PLAYER_SHIPPING_CARRIER': 'Zusteller',
  'PLAYER_SHIPPING_TRACKING': 'Tracking',
  'PLAYER_SHIPPING_PICKUP_DATE': 'Abholdatum',
  'PLAYER_SHIPPING_DELIVERY_DATE': 'Lieferdatum',
  'PLAYER_SHIPPING_DELIVERY_STATUS': 'Lieferstatus',
  'PLAYER_CONNECTIVITY_ERROR': 'Beim Laden der Verbindungsstatistik des Players ist ein Fehler aufgetreten.',
  'PLAYER_LIVE_CONNECTIVITY': 'Live-Verbindungsqualität',
  'PLAYER_HISTORY_CONNECTIVITY': 'Rückblick Verbindungsqualität',
  'PLAYER_CONNECTIVITY_LAST_UPDATE': 'Zuletzt aktualisiert:',
  'AUTH_LOGIN_PAGE_TITLE': 'Portal | Einloggen',
  'AUTH_LOST_PASSWORD_PAGE_TITLE': 'Portal | Passwort vergessen',
  'AUTH_RESET_PASSWORD_PAGE_TITLE': 'Portal | Passwort zurücksetzen',
  'DASHBOARD_PAGE_TITLE': 'Portal | Dashboard',
  'ERROR_ACCESS_DENIED_PAGE_TITLE': 'Portal | Zugriff verweigert',
  'ERROR_NOT_FOUND_PAGE_TITLE': 'Portal | Nicht gefunden',
  'PLAYERS_LIST_PAGE_TITLE': 'Portal | Player',
  'PLAYERS_DETAILS_INFO_PAGE_TITLE': 'Portal | Player | Details | Playerinformationen',
  'PLAYERS_DETAILS_PLANNING_TITLE': 'Portal | Player | Details | Tagesplan',
  'PLAYERS_DETAILS_PLAYLIST_TITLE': 'Portal | Player | Details | Playlist',
  'PLAYERS_DETAILS_PLAY_LOGS_TITLE': 'Portal | Player | Details | Play Logs',
  'PLAYERS_DETAILS_EVENT_LOGS_TITLE': 'Portal | Player | Details | Player Logs',
  'PLAYERS_DETAILS_SCHEDULED_MESSAGES_TITLE': 'Portal | Player | Details | Geplante Spots',
  'USER_PAGE_TITLE': 'Portal | Mein Profil',
  'USERS_LIST_PAGE_TITLE': 'Portal | Benutzer',
  'USERS_LIST_QUICK_SEARCH': 'Suche nach Namen',
  'USERS_DETAILS_INFO_PAGE_TITLE': 'Portal | Benutzer | Details | Benutzerinformationen',
  'USERS_DETAILS_SUBSCRIPTIONS_PAGE_TITLE': 'Portal | Benutzer | Details | Playerinformationen',
  'USERS_DETAILS_AUTH0_PAGE_TITLE': 'Portal | Benutzer | Details | Verbindungsinfo',
  'ANONYMOUS_USERNAME': 'Anonym',
  'WARNUNG': 'Warnung!',
  'USER_SUBSCRIPTIONS_IMPORT_WARNING':
    'Durch das Importieren der Playerzuweisung von einem anderen Benutzer wird die Zuweisung des aktuellen Benutzers ersetzt. Es ist UNMÖGLICH, diese Aktion abzubrechen. Sind Sie sicher, dass Sie diesen Vorgang durchführen möchten?',
  'IMAGE_UPLOAD_INVALID_EXTENSION': 'Sie versuchen, einen nicht zugelassenen Bildtyp hochzuladen. Nur JPEG- und PNG-Dateien sind zugelassen.',
  'IMAGE_UPLOAD_PROCESSING_ERROR': 'Beim Verarbeiten des Bildes ist ein Fehler aufgetreten.',
  'IMAGE_UPLOAD_GENERIC_ERROR': 'Beim Bild-Upload ist ein Fehler aufgetreten.',
  'PLAYER_AUDIO_UPDATE_SERVER': 'Server aktualisieren',
  'PLAYER_AUDIO_PLANNING_TITLE': 'Tagesplan',
  'PLAYER_AUDIO_PLAYLIST_TITLE': 'Playlist',
  'PLAYER_PLAY_LOGS_TITLE': 'Play Logs',
  'PLAYER_SCREENSHOT_TITLE': 'Screenshot',
  'PLAYER_EVENT_LOGS_TITLE': 'Player Logs',
  'PLAYER_AUDIO_SCHEDULED_MESSAGES_TITLE': 'Geplante Spots',
  'PLAYER_VIDEO_PLAYLIST_TITLE': 'Playlist',
  'AUDIO_PROGRAMS_LOAD_ERROR': 'Beim Laden der verfügbaren Audioprogramme ist ein Fehler aufgetreten.',
  'AUDIO_PLANNINGS_LOAD_ERROR': 'Beim Laden der Audioplannings ist ein Fehler aufgetreten.',
  'AUDIO_PLANNINGS_FILTER': 'Filtern',
  'AUDIO_PLANNINGS_FILTER_PROGRAM': 'Programm',
  'AUDIO_PLANNINGS_FILTER_DAY': 'Tag',
  'AUDIO_PLANNINGS_FILTER_SEARCH': 'Suche',
  'AUDIO_PLANNINGS_FILTER_RESET': 'Zurücksetzen',
  'AUDIO_PLANNINGS_START': 'Start',
  'AUDIO_PLANNINGS_NAME': 'Name',
  'AUDIO_PLANNINGS_DURATION': 'Dauer',
  'AUDIO_PLANNINGS_TYPE': 'Typ',
  'AUDIO_PLANNINGS_PLAY': 'Play',
  'MEDIA_AUDIO_MUSIC': 'Musik',
  'MEDIA_AUDIO_JINGLE': 'Jingle',
  'MEDIA_AUDIO_SEQUENCE': 'Sequenz',
  'MEDIA_AUDIO_COMMERCIAL': 'Spot',
  'MEDIA_AUDIO_PAUSE': 'Pause',
  'PLAY_LOGS_FILTER': 'Filtern',
  'PLAY_LOGS_FILTER_SEARCH': 'Suche',
  'PLAY_LOGS_FILTER_RESET': 'Zurücksetzen',
  'PLAY_LOGS_FILTER_FILENAME': 'Dateiname',
  'PLAY_LOGS_FILTER_START_DATE': 'Von (Datum)',
  'PLAY_LOGS_FILTER_START_TIME': 'Von (Zeit)',
  'PLAY_LOGS_FILTER_END_DATE': 'Bis (Datum)',
  'PLAY_LOGS_FILTER_END_TIME': 'Bis (Zeit)',
  'PLAYER_PLAY_LOGS_START_TIME': 'Startzeit',
  'PLAYER_PLAY_LOGS_END_TIME': 'Endzeit',
  'PLAYER_PLAY_LOGS_FILENAME': 'Dateiname',
  'PLAYER_PLAY_LOGS_INFO': 'Info',
  'PLAY_LOGS_LOAD_ERROR': 'Beim Laden der Play Logs für diesen Player ist ein Fehler aufgetreten.',
  'EVENT_LOGS_LOAD_ERROR': 'Beim Laden der Player Logs für diesen Player ist ein Fehler aufgetreten.',
  'EVENT_LOGS_FILTER': 'Filtern',
  'EVENT_LOGS_FILTER_START_DATE': 'Von',
  'EVENT_LOGS_FILTER_END_DATE': 'Bis',
  'EVENT_LOGS_FILTER_SEARCH': 'Suche',
  'EVENT_LOGS_FILTER_RESET': 'Zurücksetzen',
  'EVENT_LOGS_TYPE': 'Typ',
  'EVENT_LOGS_NAME': 'Name',
  'EVENT_LOGS_SOURCE': 'Quelle',
  'EVENT_LOGS_TIME': 'Zeit',
  'AUDIO_PLAYLISTS_LOAD_ERROR': 'Beim Laden der Audio-Playlisten ist ein Fehler aufgetreten.',
  'AUDIO_SCHEDULED_MESSAGES_LOAD_ERROR': 'Beim Laden der geplanten Audio-Spots ist ein Fehler aufgetreten.',
  'AUDIO_SCHEDULED_MESSAGES_FILTER': 'Filtern',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY': 'Tag',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_SEARCH': 'Suche',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_RESET': 'Zurücksetzen',
  'AUDIO_SCHEDULED_MESSAGES_ANNOUNCEMENT': 'Typ',
  'AUDIO_SCHEDULED_MESSAGES_CAMPAIGN': 'Kampagne',
  'AUDIO_SCHEDULED_MESSAGE_START_DATE': 'Von (Datum)',
  'AUDIO_SCHEDULED_MESSAGE_END_DATE': 'Bis (Datum)',
  'AUDIO_SCHEDULED_MESSAGE_START_TIME': 'Von (Zeit)',
  'AUDIO_SCHEDULED_MESSAGE_END_TIME': 'Bis (Zeit)',
  'AUDIO_SCHEDULED_MESSAGE_MONDAY': 'Mo.',
  'AUDIO_SCHEDULED_MESSAGE_TUESDAY': 'Di.',
  'AUDIO_SCHEDULED_MESSAGE_WEDNESDAY': 'Mi.',
  'AUDIO_SCHEDULED_MESSAGE_THURSDAY': 'Do.',
  'AUDIO_SCHEDULED_MESSAGE_FRIDAY': 'Fr.',
  'AUDIO_SCHEDULED_MESSAGE_SATURDAY': 'Sa.',
  'AUDIO_SCHEDULED_MESSAGE_SUNDAY': 'So.',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_NAME': 'Name',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_DURATION': 'Dauer',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_PLAY': 'Abspielen',
  'AUDIO_PLAYER_NOT_SUPPORTED': 'Ihr Browser unterstützt das Audioelement nicht.',
  'VIDEO_PLAYER_NOT_SUPPORTED': 'Ihr Browser unterstützt das Videoelement nicht.',
  'VIDEO_PLAYLISTS_LOAD_ERROR': 'Beim Laden der Videodateien ist ein Fehler aufgetreten.',
  'VIDEO_PLAYLISTS_TYPE': 'Typ',
  'VIDEO_PLAYLISTS_THUMBNAIL': 'Vorschau',
  'VIDEO_PLAYLISTS_MEDIA_NAME': 'Name',
  'VIDEO_PLAYLISTS_MEDIA_DURATION': 'Dauer',
  'VIDEO_PLAYLISTS_SOURCE': 'Quelle',
  'VIDEO_PLAYLISTS_PROGRAM_MODE': 'Spielmodus',
  'VIDEO_PLAYLISTS_PROGRAM_NAME': 'Programm Name',
  'VIDEO_PLAYLISTS_MEDIA_RESOLUTION': 'Auflösung',
  'VIDEO_PLAYLISTS_MEDIA_ROTATION': 'Ausrichtung',
  'VIDEO_PLAYLISTS_PLAY': 'Abspielen',
  'VIDEO_PLAYER': 'Video Player',
  'VIDEO_PLAYLISTS_FILTER': 'Filtern',
  'VIDEO_PLAYLISTS_FILTER_DAY': 'Tag',
  'VIDEO_PLAYLISTS_FILTER_SEARCH': 'Suche',
  'VIDEO_PLAYLISTS_FILTER_RESET': 'Zurücksetzen',
  'PLAYER_LOGS': 'Logs am Server',
  'SOCIAL_LOGIN_INTRO': 'Oder einloggen mit',
  'LOGIN_TITLE': 'Einloggen',
  'AUDIO_PLAYLIST_ADN': 'Playlist DNA',
  'AUDIO_PLAYLIST_SHOW_ADN': 'DNA anzeigen',
  'AUDIO_PLAYLIST_STATS_LOAD_ERROR': 'Beim Laden der Audio-Playlist Statistiken ist ein Fehler aufgetreten.',
  'AUDIO_PLAYLIST_ADN_TITLE': 'Playlist DNA für {{subscriptionName}}',
  'AUDIO_PLAYLIST_ADN_PROGRAM': 'Programm: {{programName}}',
  'AUDIO_PLAYLIST_ADN_DATE': 'Datum: {{date}}',
  'AUDIO_PLAYLIST_ADN_STYLES': 'Genres',
  'AUDIO_PLAYLIST_ADN_THEMES': 'Themen',
  'AUDIO_PLAYLIST_ADN_MOOD': 'Stimmung',
  'AUDIO_PLAYLIST_ADN_GENDERS': 'Geschlecht',
  'AUDIO_PLAYLIST_ADN_LANGUAGES': 'Sprache',
  'AUDIO_PLAYLIST_ADN_YEARS': 'Erscheinungsjahre',
  'AUDIO_PLAYLIST_ADN_ENERGY': 'Energie',
  'AUDIO_PLAYLIST_ADN_TEMPO': 'Tempo',
  'AUDIO_PLAYLIST_ADN_BPM': 'BPM',
  'DEFAULT_TITLE': 'Portal',
  'PLAYER_QUICK_SEARCH_PLACEHOLDER': 'Player Schnellsuche',
  'QUICK_SEARCH_BAD_REQUEST_ERROR': 'Während der Suche ist ein Fehler aufgetreten.',
  'QUICK_SEARCH_LOAD_ERROR': 'Bei der Suche des Players ist ein Fehler aufgetreten.',
  'QUICK_SEARCH_DIALOG': 'Player Schnellsuche',
  'QUICK_SEARCH_DIALOG_TITLE': 'Ergebnisse Schnellsuche',
  'PLAYER_CLIENT': 'Kunde',
  'GOTO_PLAYER': 'Player ansehen',
  'LINK_EXTERNAL_IDENTITY': 'Externe Identität verknüpfen',
  'ADMIN_ALERTS_LIST_TITLE': 'Portal | Admin | Warnmeldungen',
  'ADMIN': 'Admin',
  'ADMIN_ALERTS': 'Warnmeldungen',
  'QUICK_SEARCH_NO_RESULT': 'Ihre Suche hat kein Ergebnis.',
  'ALERT_MESSAGES_LOAD_ERROR': 'Beim Laden der Warnmeldungen ist ein Fehler aufgetreten.',
  'ALERT_MESSAGES_LIST_TITLE': 'Warnmeldungen',
  'ALERT_MESSAGES_START': 'Von',
  'ALERT_MESSAGES_END': 'Bis',
  'ALERT_MESSAGES_MESSAGE': 'Nachricht',
  'ALERT_MESSAGES_AUDIENCE': 'Empfänger',
  'ALERT_MESSAGES_ACTIONS': 'Aktionen',
  'ALERT_MESSAGES_AUDIENCE_ANY': 'Beliebig',
  'ALERT_MESSAGES_AUDIENCE_STOREVER': 'Nur MCube',
  'ALERT_MESSAGES_AUDIENCE_NOTSTOREVER': 'Nur extern',
  'ALERT_MESSAGES_EDIT': 'Bearbeiten',
  'ALERT_MESSAGES_DELETE': 'Löschen',
  'ALERT_MESSAGES_CREATE': 'Erstellen',
  'ALERT_MESSAGES_EDIT_DIALOG_TITLE': 'Warnmeldung bearbeiten',
  'ALERT_MESSAGES_CREATE_DIALOG_TITLE': 'Warnmeldung erstellen',
  'EDIT_ALERT_MESSAGE_FRENCH': 'Französisch',
  'EDIT_ALERT_MESSAGE_DUTCH': 'Niederländisch',
  'EDIT_ALERT_MESSAGE_ENGLISH': 'Englisch',
  'EDIT_ALERT_MESSAGE_GERMAN': 'Deutsch',
  'EDIT_ALERT_MESSAGE_SAVE': 'Speichern',
  'EDIT_ALERT_MESSAGE_START_DATE': 'Startdatum',
  'EDIT_ALERT_MESSAGE_END_DATE': 'Enddatum',
  'EDIT_ALERT_MESSAGE_PRODUCTS': 'Betroffene Produkte',
  'EDIT_ALERT_MESSAGE_AUDIENCE': 'Empfänger anzeigen',
  'EDIT_ALERT_MESSAGE_FRENCH_REQUIRED': 'Eine französische Nachricht ist erforderlich.',
  'EDIT_ALERT_MESSAGE_DUTCH_REQUIRED': 'Eine niederländische Nachricht ist erforderlich.',
  'EDIT_ALERT_MESSAGE_ENGLISH_REQUIRED': 'Eine englische Nachricht ist erforderlich.',
  'EDIT_ALERT_MESSAGE_FRENCH_MAX_LENGTH': 'Eine französische Nachricht darf nicht länger als 500 Zeichen sein.',
  'EDIT_ALERT_MESSAGE_DUTCH_MAX_LENGTH': 'Eine niederländische Nachricht darf nicht länger als 500 Zeichen sein.',
  'EDIT_ALERT_MESSAGE_ENGLISH_MAX_LENGTH': 'Eine englische Nachricht darf nicht länger als 500 Zeichen sein.',
  'EDIT_ALERT_MESSAGE_BROADCAST_REQUIRED': 'Ein Empfänger ist erforderlich.',
  'EDIT_ALERT_MESSAGE_PRODUCTS_RESET': 'Zurücksetzen',
  'CREATE_ALERT_MESSAGE_SUCCESS': 'Die Warnmeldung wurde erfolgreich erstellt.',
  'CREATE_ALERT_MESSAGE_VALIDATION_ERROR': 'Beim Erstellen der Warnmeldung ist ein Validierungsfehler aufgetreten.',
  'CREATE_ALERT_MESSAGE_ERROR': 'Beim Erstellen der Warnmeldung ist ein Fehler aufgetreten.',
  'UPDATE_ALERT_MESSAGE_SUCCESS': 'Die Warnmeldung wurde erfolgreich aktualisiert.',
  'UPDATE_ALERT_MESSAGE_VALIDATION_ERROR': 'Beim Aktualisieren der Warnmeldung ist ein Validierungsfehler aufgetreten.',
  'UPDATE_ALERT_MESSAGE_ERROR': 'Beim Aktualisieren der Warnmeldung ist ein Fehler aufgetreten.',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG': 'Bestätigungsdialog für Warnmeldung löschen',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_TITLE': 'Bestätigung löschen',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_ACCEPT': 'Löschen',
  'CONFIRM_DELETE_ALERT_MESSAGE_MESSAGE': 'Möchten Sie diese Warnmeldung wirklich löschen?',
  'DELETE_ALERT_MESSAGE_SUCCESS': 'Die Warnmeldung wurde erfolgreich gelöscht.',
  'DELETE_ALERT_MESSAGE_ERROR': 'Beim Löschen der Warnmeldung ist ein Fehler aufgetreten.',
  'CURRENT_ALERT_MESSAGES_ERROR': 'Beim Laden der aktuellen Warnmeldungen ist ein Fehler aufgetreten.',
  'ADMIN_ROLES_MANAGER_TITLE': 'Portal | Admin | Rollenmanager',
  'ADMIN_ROLES_MANAGER': 'Rollenmanager',
  'ROLES_MANAGER_TITLE': 'Rollenmanager',
  'ROLES_MANAGER_GROUP_ROLES': 'Rollengruppe',
  'ROLES_MANAGER_ADD_GROUP': 'Hinzufügen',
  'ROLES_MANAGER_REMOVE_GROUP': 'Löschen',
  'ROLES_MANAGER_SELECT_GROUP': '--- Wähle eine Rollengruppe ---',
  'GROUP_ROLE_EX_LOAD_ERROR': 'Beim Laden der Rollengruppendetails ist ein Fehler aufgetreten.',
  'ADMIN_GROUP_ROLE_NAME': 'Name',
  'ADMIN_GROUP_ROLE_SAVE': 'Speichern',
  'CREATE_GROUP_ROLES_DIALOG': 'Neue Rollengruppe erstellen',
  'CREATE_GROUP_ROLES_TITLE': 'Rollengruppe erstellen',
  'CREATE_GROUP_ROLES_BUTTON': 'Erstellen',
  'GROUP_ROLES_NAME_TEMPLATE': 'Vorhandene Vorlage auswählen.',
  'GROUP_ROLES_NAME': 'Neue Rollengruppe erstellen.',
  'GROUP_ROLES_NAME_REQUIRED': 'Der Name der Rollengruppe ist erforderlich.',
  'GROUP_ROLES_NAME_MIN_LENGTH': 'Der Name der Rollengruppe muss mindestens 3 Zeichen lang sein.',
  'GROUP_ROLES_NAME_MAX_LENGTH': 'Der Name der Rollengruppe darf nicht länger als 50 Zeichen sein.',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG': 'Bestätigungsdialog für Rollengruppe löschen',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG_TITLE': 'Bestätigung löschen',
  'CONFIRM_DELETE_EMPTY_GROUP_ROLES_MESSAGE': 'Möchten Sie die Rollengruppe "{{name}}" wirklich löschen?',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG_ACCEPT': 'Löschen',
  'CREATE_GROUP_ROLES_SUCCESS': 'Die Rollengruppen wurden erfolgreich erstellt.',
  'CREATE_GROUP_ROLES_VALIDATION_ERROR': 'Beim Erstellen der Rollengruppe ist ein Validierungsfehler aufgetreten.',
  'CREATE_GROUP_ROLES_ERROR': ' Beim Erstellen der Rollengruppe ist ein Fehler aufgetreten.',
  'UPDATE_GROUP_ROLES_SUCCESS': 'Die Rollengruppen wurden erfolgreich aktualisiert.',
  'UPDATE_GROUP_ROLES_VALIDATION_ERROR': 'Beim Aktualisieren der Rollengruppe ist ein Validierungsfehler aufgetreten.',
  'UPDATE_GROUP_ROLES_ERROR': 'Beim Aktualisieren der Rollengruppe ist ein Fehler aufgetreten.',
  'DELETE_GROUP_ROLES_SUCCESS': 'Die Rollengruppen wurden erfolgreich gelöscht.',
  'DELETE_GROUP_ROLES_ERROR': 'Beim Löschen der Rollengruppe ist ein Fehler aufgetreten.',
  'EXTERNAL_APPS': 'Weitere Apps',
  'ROLE_VIEW': 'Kann auf Portal zugreifen',
  'ROLE_PORTAL_ACTION': 'Kann Aktionen ausführen',
  'ROLE_PORTAL_EVENTLOG': 'Kann Player Logs ansehen',
  'ROLE_PORTAL_PLAYLOG': 'Kann Play Logs ansehen',
  'ROLE_PORTAL_PLANNING': 'Kann Planning ansehen',
  'ROLE_PORTAL_TICKET': 'Kann Tickets ansehen',
  'ROLE_RUNAS': 'Kann sich als ein anderer Benutzer darstellen',
  'ROLE_PORTAL_USERMGR': 'Kann Benutzer verwalten',
  'ROLE_PORTAL_STOREVER': 'Hat Zugriff auf MCube-Ansichten',
  'ROLE_PORTAL_EXPERT': 'Hat Zugriff auf erweiterte Ansichten',
  'ROLE_PORTAL_PUBLISH': 'Kann auf einem Player publishen',
  'ROLE_PORTAL_REBOOT': 'Kann einen Player neu starten',
  'ROLE_PORTAL_SRVLOG': 'Kann Server Logs ansehen',
  'ROLE_DS_MEDIA': 'Kann auf die Medienverwaltung zugreifen',
  'ROLE_DS_UPLOAD': 'Kann neue Medien hochladen',
  'ROLE_DS_EXPERT': 'Hat Zugriff auf erweiterte Ansichten und Aktionen',
  'ROLE_CREATOR_UPLOAD_IMG': 'Kann Bilder hochladen',
  'ROLE_CREATOR_UPLOAD_SHAPE': 'Kann Formen hochladen',
  'ROLE_CREATOR_TEMPLATE_NEW': 'Kann neue Vorlagen erstellen',
  'ROLE_CREATOR_TEMPLATE_SHARE': 'Kann Vorlagen teilen',
  'ROLE_DS_SHARE': 'Kann Medien / Wiedergabelisten / Programme teilen',
  'ROLE_DS_ROTATE_MEDIA': 'Kann Medien drehen',
  'ROLE_CREATOR_EXPERT': 'Hat Zugriff auf erweiterte Ansichten und Aktionen',
  'ROLE_APS_PROGRAM': 'Kann Programme verwalten',
  'SITE_TITLE': 'Portal',
  'ROLE_DS_PUBLISH': 'Kann auf die Player publishen',
  'COMMANDS_LOAD_ERROR': 'Beim Laden der Befehle des Players ist ein Fehler aufgetreten.',
  'PLAYER_COMMANDS_TITLE': 'Gesendete Befehle',
  'PLAYER_COMMANDS_PAGE_TITLE': 'Portal | Player | Details | Befehle',
  'COMMANDS_FILTER': 'Filtern',
  'COMMANDS_FILTER_DAY': 'Tag',
  'COMMANDS_FILTER_SEARCH': 'Suche',
  'COMMANDS_FILTER_RESET': 'Zurücksetzen',
  'COMMANDS_TEXT': 'Befehl',
  'COMMANDS_NAME': 'Name',
  'COMMANDS_USER': 'Creator',
  'COMMANDS_SEND_DATE': 'Gesendet',
  'COMMANDS_RESULT_DATE': 'Beantwortet',
  'COMMAND_CUSTOM': 'Benutzerdefiniert ...',
  'COMMAND_CTEST': 'Verbindungstest',
  'COMMAND_DIR': 'Inhalt auflisten',
  'COMMAND_CURCHAN': 'Aktueller Kanal',
  'COMMAND_KCHK': 'Entschlüsselungsschlüssel prüfen',
  'COMMAND_CHKDSK': 'Disk überprüfen',
  'COMMAND_ISP': 'Konfigurieren',
  'COMMAND_STASK': 'Aufgabenliste abrufen',
  'COMMAND_DC': 'Verbindung trennen',
  'COMMAND_PP_1': 'Playlist 1 abspielen',
  'COMMAND_PS_1': 'Station 1 abspielen',
  'COMMAND_POWER_ON': 'Einschalten',
  'COMMAND_POWER_OFF': 'Ausschalten',
  'COMMAND_RANDOM_ON': 'Zufallsmodus Einschalten',
  'COMMAND_RANDOM_OFF': 'Zufallsmodus Ausschalten',
  'COMMAND_STATUS': 'Status',
  'COMMAND_TCP_FAST': 'TCP Schnell',
  'COMMAND_TCP_NORMAL': 'TCP Normal',
  'COMMAND_TCP_ULTRAFAST': 'TCP Ultraschnell',
  'COMMAND_RESTART': 'Neustarten',
  'COMMAND_SAF': 'Update-URL abrufen',
  'COMMAND_SDTEST': 'SD-Karte testen',
  'COMMAND_SNUM': 'Seriennummer abrufen',
  'COMMAND_CHANNEL': 'Kanalliste abrufen',
  'COMMAND_SYSTAT': 'Systemstatus abrufen',
  'COMMAND_TIME': 'Zeit abrufen',
  'COMMAND_UCP': 'Zeitplan aktualisieren',
  'COMMAND_UCA': 'Werbung aktualisieren',
  'COMMAND_UP': 'Update',
  'COMMAND_IDINBG_0': 'Update im Hintergrund deaktivieren',
  'COMMAND_IDINBG_1': 'Update im Hintergrund aktivieren',
  'COMMAND_IDINBG_OFF': 'Update im Hintergrund deaktivieren',
  'COMMAND_IDINBG_ON': 'Update im Hintergrund aktivieren',
  'COMMAND_UD': 'Konfiguration aktualisieren',
  'COMMAND_UO': 'Nur Playliste aktualisieren',
  'COMMAND_UF': 'Firmware aktualisieren',
  'COMMAND_US': 'Plan aktualisieren',
  'COMMAND_VOLUME_MAX': 'Maximales Volumen auswählen',
  'SEND_COMMAND_SUCCESS': 'Der Befehl ist in der Warteschlange und wird in Kürze an den Player gesendet.',
  'SEND_COMMAND_FAIL': 'Beim Senden des Befehls ist ein Fehler aufgetreten.',
  'CUSTOM_COMMAND_DIALOG': 'Benutzerdefinierter Player-Befehlsdialog',
  'CUSTOM_COMMAND_DIALOG_TITLE': 'Benutzerdefinierter Befehl',
  'SEND_COMMAND_BUTTON': 'Senden',
  'CUSTOM_COMMAND_LABEL': 'Geben Sie den Befehl ein, der an den Player gesendet werden soll:',
  'CUSTOM_COMMAND_REQUIRED': 'Der Befehl ist erforderlich.',
  'DASHBOARD_ADVANCED_COUNTERS_ERROR': 'Beim Laden der erweiterten Zähler ist ein Fehler aufgetreten.',
  'DASHBOARD_COUNTERS_ERROR': 'Beim Laden der Zähler ist ein Fehler aufgetreten.',
  'RELOAD': 'Neuladen',
  'LADEN': 'Laden ...',
  'DASHBOARD_COUNTERS_TITLE_LOADING': 'Playerstatistik',
  'DASHBOARD_COUNTERS_TITLE_LOADED': 'Playerstatistik ({{count}} Player insgesamt)',
  'DASHBOARD_COUNTERS_PLAYER_TYPE_CHART': 'Player-Typen',
  'DASHBOARD_COUNTERS_PLAYER_AUDIO_CHART': 'Audio Player',
  'DASHBOARD_COUNTERS_PLAYER_VIDEO_CHART': 'Video Player',
  'DASHBOARD_COUNTERS_PLAYER_ONLINE_STATUS_CHART': 'Online-Status',
  'DASHBOARD_COUNTERS_PLAYER_ONLINE_CHART': 'Online',
  'DASHBOARD_COUNTERS_PLAYER_OFFLINE_CHART': 'Offline',
  'DASHBOARD_COUNTERS_PLAYER_UPDATE_STATUS_CHART': 'Status aktualisieren',
  'DASHBOARD_COUNTERS_PLAYER_UPDATED_CHART': 'Update erfolgreich',
  'DASHBOARD_COUNTERS_PLAYER_NOT_UPDATED_CHART': 'Update nicht erfolgreich',
  'DASHBOARD_COUNTERS_PLAYER_UPDATE_INCOMPLETE_CHART ': ' Update unvollständig',
  'DASHBOARD_COUNTERS_POINT_FORMAT_PART1': 'Anzahl der Player:',
  'DASHBOARD_COUNTERS_POINT_FORMAT_PART2': 'Prozentsatz der Player:',
  'PLAYER_CONNECTIVITY_STATS_ERROR': 'Beim Laden der Player-Verbindungsstatistik ist ein Fehler aufgetreten.',
  'DASHBOARD_CONNECTIVITY_STATS_ERROR': 'Beim Laden der Kunden-Verbindungsstatistik ist ein Fehler aufgetreten.',
  'DASHBOARD_CONNECTIVITY_TITLE': 'Verbindungsstatistik',
  'DASHBOARD_UPDATE_TITLE': 'Statistiken zu Spieleraktualisierungen',
  'DASHBOARD_CONNECTIVITY_CHART_TITLE': 'Verbindungsqualität aller Player',
  'DASHBOARD_CONNECTIVITY_CHART_SUBTITLE': 'Klicken und ziehen Sie die Maus in den Diagrammbereich, um ihn zu vergrößern',
  'DASHBOARD_CONNECTIVITY_CHART_YAXIS': 'Verbindungsqualität',
  'DASHBOARD_UPDATE_CHART_TITLE': 'Alle Spieler aktualisieren',
  'DASHBOARD_UPDATE_CHART_SUBTITLE': 'Klicken und ziehen Sie die Maus in den Diagrammbereich, um ihn zu vergrößern',
  'DASHBOARD_UPDATE_CHART_YAXIS': 'Qualität aktualisieren',
  'DASHBOARD_SHIPPING_ERROR': 'Beim Laden der Versandliste ist ein Fehler aufgetreten.',
  'DASHBOARD_SHIPPING_INFO_TITLE': 'Versandinformationen',
  'DASHBOARD_SHIPPING_NAME': 'Name',
  'DASHBOARD_SHIPPING_TYPE': 'Typ',
  'DASHBOARD_SHIPPING_CARRIER': 'Versandunternehmen',
  'DASHBOARD_SHIPPING_TRACKING': 'Tracking',
  'DASHBOARD_SHIPPING_PICKUP_DATE': 'Abholdatum',
  'DASHBOARD_SHIPPING_DELIVERY_DATE': 'Lieferdatum',
  'DASHBOARD_SHIPPING_DELIVERY_STATUS': 'Lieferstatus',
  'DASHBOARD_SHIPPING_NO_DATA': 'Hier können keine Daten angezeigt werden.',
  'DASHBOARD_ACTIVITY_FEED_TITLE': 'Aktivitäts-Feed',
  'DASHBOARD_ACTIVITY_FEED_ERROR': 'Beim Laden des Aktivitäts-Feeds ist ein Fehler aufgetreten.',
  'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLE': '{{userName}} hat Gruppenrollen {{name}} erstellt',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLE': '{{userName}} aktualisierte Gruppenrollen {{name}}',
  'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLE': '{{userName}} löschte Gruppenrollen {{name}}',
  'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLES': '{{userName}} hat {{count}} Gruppenrollen erstellt',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLES': '{{userName}} hat {{count}} Gruppenrollen aktualisiert ',
  'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLES': '{{userName}} hat {{count}} Gruppenrollen gelöscht',
  'DASHBOARD_ACTIVITY_FEED_CREATE_USER': '{{userName}} hat einen Benutzer <a href="/users/{{uuid}}"> {{name}} </a> erstellt',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_USER': '{{userName}} aktualisierter Benutzer <a href="/users/{{uuid}}"> {{name}} </a>',
  'DASHBOARD_ACTIVITY_FEED_DELETE_USER': '{{userName}} löschte Benutzer {{name}}',
  'DASHBOARD_ACTIVITY_FEED_CREATE_USERS': '{{userName}} hat {{count}} Benutzer erstellt',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_USERS': '{{userName}} aktualisierte {{count}} Benutzer',
  'DASHBOARD_ACTIVITY_FEED_DELETE_USERS': '{{userName}} löschte {{count}} Benutzer',
  'DASHBOARD_ACTIVITY_FEED_NO_DATA': 'Hier kann keine Aktivität angezeigt werden.',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_CLIENT': '{{userName}} Kunde aktualisieren',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_SCHEDULE_AUDIO_COMMERCIAL': '{{userName}} Audiowerbung planen',
  'DASHBOARD_ACTIVITY_FEED_DELETE_MEDIA': '{{userName}} Datenträger löschen',
  'DASHBOARD_ACTIVITY_FEED_TEST_CLIENT': '{{userName}} Testkunde',
  'DASHBOARD_LAST_SERVER_CALL_ERROR': 'Beim Laden des letzten Serveraufrufs ist ein Fehler aufgetreten.',
  'DASHBOARD_LAST_SERVER_CALL_TITLE': 'Relay Server Status',
  'DASHBOARD_LAST_SERVER_CALL_ONLINE': 'Der Server ist online',
  'DASHBOARD_LAST_SERVER_CALL_OFFLINE': 'Der Server ist offline',
  'DASHBOARD_LAST_SERVER_CALL_NO_DATA': 'Hier kann kein Relay-Server-Status angezeigt werden.',
  'DASHBOARD_LOGMATIC_ANALYZES_TITLE': 'Logmatic Report',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR': 'Beim Laden des Protokollberichts ist ein Fehler aufgetreten.',
  'DASHBOARD_LOGMATIC_ANALYZES_NO_DATA': 'Es gibt keinen Bericht, der hier angezeigt werden könnte.',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR_CODE': 'Fehlercode',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR_NUMBER': '# Fehler',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS': 'Lieferstatus',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DELIVERED': 'Geliefert',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_IN_TRANSIT': 'Wird geliefert',
  'AUTH_LOGIN_TITLE': 'Einloggen',
  'ADMIN_CLIENTS_LIST_TITLE': 'Portal | Admin | Kunden',
  'ADMIN_CLIENTS': 'Kunden',
  'ADMIN_CLIENTS_LIST_FILTER': 'Filtern',
  'ADMIN_CLIENTS_LIST_FILTER_SEARCH': 'Suche',
  'ADMIN_CLIENTS_LIST_FILTER_RESET': 'Zurücksetzen',
  'ADMIN_CLIENTS_LIST_FILTER_NAME': 'Name',
  'ADMIN_CLIENTS_LIST_FILTER_OFFICE': 'Büro',
  'ADMIN_CLIENTS_LIST_FILTER_SALES': 'Sales',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES': 'Services',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_DEFAULT': '',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_AUDIO': 'Audio',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_VIDEO': 'Video',
  'ADMIN_CLIENTS_LIST_CREATE': 'Erstellen',
  'CLIENTS_LIST_LOAD_BAD_REQUEST_ERROR': 'Im Suchfilter ist ein Fehler aufgetreten.',
  'CLIENTS_LIST_LOAD_ERROR': 'Beim Abrufen der Kundenliste ist ein Fehler aufgetreten.',
  'ADMIN_CLIENTS_NAME': 'Name',
  'ADMIN_CLIENTS_CUSTOMER_ID': 'Customer ID',
  'ADMIN_CLIENTS_C_NAME': 'CName',
  'ADMIN_CLIENTS_OFFICE': 'Büro',
  'ADMIN_CLIENTS_SALES': 'Sales',
  'ADMIN_CLIENTS_SERVICES': 'Service(s)',
  'ADMIN_CLIENTS_UPDATED': 'Aktualisiert',
  'ADMIN_CLIENTS_CREATED': 'Erstellt',
  'SALES_LOAD_ERROR': 'Beim Abrufen der Sales-Liste ist ein Fehler aufgetreten.',
  'ADMIN_EDIT_CLIENT': 'Portal | Admin | Kunden bearbeiten',
  'ADMIN_CREATE_CLIENT': ' Portal | Admin | Kunden erstellen ',
  'CLIENT_LOAD_ERROR': 'Beim Laden der Kunde-Details ist ein Fehler aufgetreten.',
  'EDIT_CLIENT_TITLE': 'Kunden {{name}} bearbeiten',
  'CREATE_CLIENT_TITLE': 'Neuen Kunden erstellen',
  'SAVE_CLIENT_BUTTON': 'Speichern',
  'CREATE_CLIENT_BUTTON': 'Erstellen',
  'CLIENT_NAME': 'Name',
  'CLIENT_OFFICE': 'Büro',
  'CLIENT_SALES': 'Sales',
  'CLIENT_SERVICES': 'Services',
  'CLIENT_SERVICE_AUDIO': 'Audio',
  'CLIENT_SERVICE_VIDEO': 'Video',
  'CLIENT_APPLICATIONS': 'Apps',
  'CURRENT_CLIENT_LOAD_ERROR': 'Beim Laden der aktuellen Kundeninformationen ist ein Fehler aufgetreten.',
  'CLIENT_SALES_ME_BUTTON': 'Ich!',
  'ADMIN_CLIENT_NOT_SALESMAN': 'Sie werden nicht als Sales bezeichnet. Wählen Sie einen Sales aus der Dropdown-Liste aus.',
  'CLIENT_NAME_REQUIRED': 'Der Kundenname ist erforderlich.',
  'CLIENT_NAME_MAX_LENGTH': 'Der Kundenname darf nicht länger als 50 Zeichen sein.',
  'CLIENT_OFFICE_REQUIRED': 'Das Büro ist erforderlich.',
  'CLIENT_SALES_REQUIRED': 'Der Sales ist erforderlich.',
  'CLIENT_APPS_LOAD_ERROR': 'Beim Laden der Kunden-Apps ist ein Fehler aufgetreten.',
  'CREATE_CLIENT_VALIDATION_ERROR': 'Beim Erstellen des Kunden ist ein Validierungsfehler aufgetreten.',
  'CREATE_CLIENT_ERROR': 'Beim Erstellen des Kunden ist ein Fehler aufgetreten.',
  'CREATE_CLIENT_SUCCESS': 'Der neue Kunde wurde erfolgreich erstellt.',
  'UPDATE_CLIENT_VALIDATION_ERROR': 'Beim Aktualisieren des Kunden ist ein Validierungsfehler aufgetreten.',
  'UPDATE_CLIENT_ERROR': 'Beim Aktualisieren des Kunden ist ein Fehler aufgetreten.',
  'UPDATE_CLIENT_SUCCESS': 'Der Kunde wurde erfolgreich aktualisiert.',
  'AUTH_LOGIN_ERROR_TITLE': 'Ein Fehler ist aufgetreten',
  'AUTH_LOGIN_ERROR_PARA': 'Beim Anmelden ist folgender Fehler aufgetreten:',
  'AUTH_LOGIN_GO_BACK_BUTTON': 'Zurück zur Anmeldeseite',
  'USER_PROFILE_LOAD_ERROR': 'Beim Laden Ihres Benutzerprofils ist ein Fehler aufgetreten.',
  'USER_UNBLOCKED': ' ',
  'USER_BLOCKED': 'Gesperrt',
  'AUTH_NEW_PASSWORD_PAGE_TITLE': 'Portal | Wählen Sie Ihr Passwort',
  'AUTH_NEW_PASSWORD_TITLE': 'Wählen Sie Ihr Passwort',
  'AUTH_NEW_PASSWORD_PARA': 'Geben Sie Ihr Passwort ein und bestätigen Sie es.',
  'AUTH_NEW_PASSWORD_ERROR': 'Beim Speichern Ihres Passworts ist ein Fehler aufgetreten.',
  'AUTH_NEW_PASSWORD_SUCCESS': 'Ihr Passwort wurde gespeichert.',
  'AUTH_NEW_PASSWORD_NEW': 'Passwort',
  'AUTH_NEW_PASSWORD_NEW_REQUIRED': 'Das Passwort ist erforderlich.',
  'AUTH_NEW_PASSWORD_NEW_MINLENGTH': 'Das Passwort muss mindestens 4 Zeichen lang sein.',
  'AUTH_NEW_PASSWORD_CONFIRM': 'Passwortbestätigung',
  'AUTH_NEW_PASSWORD_CONFIRM_MISMATCH': 'Das Passwort und seine Bestätigung stimmen nicht überein.',
  'AUTH_NEW_PASSWORD_SUBMIT': 'Prüfen',
  'AUTH_NEW_PASSWORD_SUBMITTING': 'Wird geprüft...',
  'PAGER_FIRST': 'Erste',
  'PAGER_PREVIOUS': 'Zurück',
  'PAGER_NEXT': 'Nächste',
  'PAGER_LAST': 'Letzte',
  'USER_SUBSCRIPTIONS_FILTER': 'Player filtern',
  'EDIT_ALERT_MESSAGE_START_DATE_REQUIRED': 'Das Startdatum ist erforderlich.',
  'EDIT_ALERT_MESSAGE_START_DATE_INVALID': 'Das Startdatum ist ungültig (das Format lautet TT / MM / JJJJ HH:mm).',
  'EDIT_ALERT_MESSAGE_END_DATE_REQUIRED': 'Das Enddatum ist erforderlich.',
  'EDIT_ALERT_MESSAGE_END_DATE_INVALID': 'Das Enddatum ist ungültig (das Format lautet TT / MM / JJJJ HH:mm).',
  'EDIT_ALERT_MESSAGE_END_DATE_NOT_AFTER_START_DATE': 'Das Enddatum muss nach dem Startdatum liegen.',
  'EDIT_ALERT_MESSAGE_START_DATE_TOO_EARLY': 'Das Startdatum darf nicht in der Vergangenheit liegen.',
  'COMMAND_LIST_FILTER_DAY_REQUIRED': 'Das Datum ist erforderlich.',
  'COMMAND_LIST_FILTER_DAY_INVALID': 'Das Datum ist ungültig (das Format lautet TT / MM / JJJJ).',
  'DATE_TIME_PLACEHOLDER': 'TT / MM / JJJJ HH: mm',
  'DATE_PLACEHOLDER': 'TT / MM / JJJJ',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_REQUIRED': 'Das Datum ist erforderlich.',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_INVALID': 'Das Datum ist ungültig (das Format lautet TT / MM / JJJJ).',
  'VIDEO_PLAYLIST_FILTER_DAY_REQUIRED': 'Das Datum ist erforderlich.',
  'VIDEO_PLAYLIST_FILTER_DAY_INVALID': 'Das Datum ist ungültig (das Format lautet TT / MM / JJJJ).',
  'VIDEO_PLAYLIST_FILTER_DAY_NOT_IN_RANGE': 'Das Datum muss zwischen {{from}} und {{to}} liegen.',
  'AUDIO_PLANNING_FILTER_DAY_REQUIRED': 'Das Datum ist erforderlich.',
  'AUDIO_PLANNING_FILTER_DAY_INVALID': 'Das Datum ist ungültig (das Format lautet TT / MM / JJJJ).',
  'AUDIO_PLANNING_FILTER_DAY_NOT_IN_RANGE': 'Das Datum muss zwischen {{from}} und {{to}} liegen.',
  'EVENT_LOGS_FILTER_START_DATE_REQUIRED': 'Das Datum "ab" ist erforderlich.',
  'EVENT_LOGS_FILTER_START_DATE_INVALID': 'Das Datum "ab" ist ungültig (das Format lautet TT / MM / JJJJ HH: mm).',
  'EVENT_LOGS_FILTER_END_DATE_REQUIRED': 'Das Datum "bis" ist erforderlich.',
  'EVENT_LOGS_FILTER_END_DATE_INVALID': 'Das Datum "bis" ist ungültig (das Format lautet TT / MM / JJJJ HH: mm).',
  'EVENT_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': 'Das "ab"-Datum muss vor dem "bis"-Datum liegen.',
  'PLAY_LOGS_FILTER_START_DATE_REQUIRED': 'Das Datum "ab" ist erforderlich.',
  'PLAY_LOGS_FILTER_START_DATE_INVALID': 'Das Datum "ab" ist ungültig (das Format lautet TT / MM / JJJJ HH: mm).',
  'PLAY_LOGS_FILTER_END_DATE_REQUIRED': 'Das "bis"-Datum ist erforderlich.',
  'PLAY_LOGS_FILTER_END_DATE_INVALID': 'Das Datum "bis" ist ungültig (das Format lautet TT / MM / JJJJ HH: mm).',
  'PLAY_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': 'Das "ab"-Datum muss vor dem "bis"-Datum liegen.',
  'PLAY_LOGS_FILTER_EXCEEDED': 'Play Logs haben eine maximale Dauer von {{logs}} Tagen',
  'DASHBOARD_ACTIVITY_FEED_CREATE_CLIENT': '{{userName}} hat den Kunden {{name}} erstellt',
  'DATATABLE_DEFAULT_EMPTY_TEXT': 'Hier können keine Daten angezeigt werden.',
  'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_ONE':
    'Der Benutzer ist noch der Gruppenrolle " {{name}} "zugeordnet. Welche andere Gruppenrolle möchten Sie ihm zuweisen?',
  'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_MANY':
    '{{count}} Benutzer sind noch der Gruppenrolle " {{name}} "zugeordnet. Welche andere Gruppenrolle möchten Sie diesen zuweisen?',
  'ADMIN_CLIENTS_APPS': 'App(s)',
  'ADMIN_CLIENT_APP_1': 'Portal',
  'ADMIN_CLIENT_APP_2': 'DSManager',
  'ADMIN_CLIENT_APP_3': 'Creator',
  'ADMIN_CLIENT_APP_4': 'ADManager',
  'DATETIME_PICKER_TODAY': 'Heute auswählen',
  'DATETIME_PICKER_CLEAR': 'Auswahl aufheben',
  'DATETIME_PICKER_CLOSE': 'Auswahl schließen',
  'DATETIME_PICKER_SELECT_MONTH': 'Monat auswählen',
  'DATETIME_PICKER_PREV_MONTH': 'Vorheriger Monat',
  'DATETIME_PICKER_NEXT_MONTH': 'Nächster Monat',
  'DATETIME_PICKER_SELECT_YEAR': 'Jahr auswählen',
  'DATETIME_PICKER_PREV_YEAR': 'Vorheriges Jahr',
  'DATETIME_PICKER_NEXT_YEAR': 'Nächstes Jahr',
  'DATETIME_PICKER_SELECT_DECADE': 'Jahrzehnt auswählen',
  'DATETIME_PICKER_PREV_DECADE': 'Vorheriges Jahrzehnt',
  'DATETIME_PICKER_NEXT_DECADE': 'Nächstes Jahrzehnt',
  'DATETIME_PICKER_PREV_CENTURY': 'Vorheriges Jahrhundert',
  'DATETIME_PICKER_NEXT_CENTURY': 'Nächstes Jahrhundert',
  'DATETIME_PICKER_INCREMENT_HOUR': 'Stunde erhöhen',
  'DATETIME_PICKER_PICK_HOUR': 'Stunde auswählen',
  'DATETIME_PICKER_DECREMENT_HOUR': 'Stunde verringern',
  'DATETIME_PICKER_INCREMENT_MINUTE': 'Minute erhöhen',
  'DATETIME_PICKER_PICK_MINUTE': 'Minute auswählen',
  'DATETIME_PICKER_DECREMENT_MINUTE': 'Minute verringern',
  'DATETIME_PICKER_INCREMENT_SECOND': 'Sekunde erhöhen',
  'DATETIME_PICKER_PICK_SECOND': 'Sekunde auswählen',
  'DATETIME_PICKER_DECREMENT_SECOND': 'Sekunde verringern',
  'CULTURE_COMMON': 'Kulturen',
  'CULTURE_OTHERS': 'Andere Kulturen',
  'PLAYER_PLAY_LOGS_NAME': 'Name',
  'PLAYER_CACHE': 'Server-Cache',
  'ROLE_APS_MEDIA': 'Kann neue Medien verwalten',
  'ROLE_APS_PUBLISH': 'Kann auf Player publishen',
  'ROLE_APS_EXPERT': 'Hat Zugriff auf erweiterte Ansichten und Aktionen',
  'CREATE_USER_NO_GROUPS': 'Für diesen Kunden sind keine Gruppenrollen definiert.',
  'EDIT_CLIENT_INFO': 'Kundeninfo',
  'INVENTORY_LAST_MODIFICATION': 'Letzte Änderung',
  'WARNING_MESSAGE_PLANNING_UPDATE_FAIL':
    'Die tatsächliche Titelabfolge kann von der musikalischen Planung abweichen. Die Titelabfolge kann unabhängig vom Player durch viele Faktoren beeinträchtigt werden. Beispielsweise kann das Hinzufügen von Werbespots zu einer Verschiebung des Musikplans führen. Auch die Verbindungsqualität, Internetgeschwindigkeit und Downloadrate kann von Filiale zu Filiale unterschiedlich sein, was sich ebenfalls auf die Playlist und Titelreihenfolge auswirkt.',
  'WARNING_MESSAGE_PLAYLIST_UPDATE_FAIL':
    'Die Playlisten können unabhängig vom Player durch viele Faktoren geändert werden. Wenn beispielsweise die tägliche Aktualisierung fehlgeschlagen oder unvollständig ist, werden die fehlenden Audiodateien nicht gesendet und durch andere Titel ersetzt.',
  'WARNING_TITLE_UPDATE_FAIL': 'Zu Ihrer Information',
  'ROLE_APS_CAMPAIGN': 'Kann die Kampagnen verwalten',
  'ROLE_APS_UPLOAD': 'Kann neue Medien hinzufügen',
  'ROLE_APS_SHARE': 'Kann Medien teilen',
  'ROLE_APS_MUSTVALIDMEDIA': 'Mediadatei muss validiert werden',
  'ROLE_VIEW_CORPORATE': 'Alle anzeigen',
  'ROLE_APS_CAMPAIGN_SUBSCRIPTION': 'Kann lokale Kampagnen verwalten',
  'ROLE_EDIT_CORPORATE': 'Alle bearbeiten',
  'ROLE_PORTAL_VIEWUPDATESTATUS': 'Update-Status des Players ansehen',
  'ROLE_DS_PLAYLIST': 'Kann die Playlisten verwalten',
  'ROLE_DS_PROGRAM': 'Kann die Programme verwalten',
  'ROLE_PORTAL_OPENING': 'Kann die Öffnungszeiten verwalten',
  'ROLE_PORTAL_INVENTORY': 'Kann die Speicherinhalte ansehen',

  'GO_BACK': 'Zurück',
  'PRIVACY_POLICY': 'Datenschutzerklärung',
  'TERMS_OF_USE': 'Nutzungsbedingungen',

  'CLUF_TERMS_OF_USE': 'NUTZUNGSBEDINGUNGEN',
  'CLUF_TERMS_OF_USE_TEXT':
    'Diese Allgemeinen Geschäftsbedingungen definieren die Bedingungen für den Zugriff auf und die Nutzung der MCube-Website und verwandter Websites (im Folgenden "Website") sowie die Nutzungsbedingungen für interaktive Dienste (die für Sie angebotenen und verwalteten Dienste) (im Folgenden "Nutzer") von MCube auf ihrer Website. Die Dienste sind für MCube-Kunden (im Folgenden die "Kunden") nur für die Dauer des Audiovertrags (Audio und / oder Video) (im Folgenden der "Vertrag"), den sie mit MCube geschlossen haben, zugänglich, einschließlich Hosting-Diensten , das Versenden von Newslettern, die Bereitstellung von auf Kundenwunsch erstellten Inhalten und von Werkzeugen zur Erstellung von Multimediainhalten und Nachrichtenprogrammen sowie von audiovisuellen Kampagnen (im Folgenden "Inhalte"). Zu den Dienstleistungen gehört auch die Bereitstellung von Tools zur Verwaltung der Software des Kunden (im Folgenden "Software") sowie der Kundendienst. Die Nutzung der Dienste bedeutet, dass Sie mit diesen Nutzungsbedingungen einverstanden sind. Einige zusätzliche oder spezielle Bedingungen gelten möglicherweise für bestimmte Dienste. Diese zusätzlichen Bedingungen werden daher mit Nutzung der Dienste akzeptiert. ',

  'CLUF_USE_OF_OUR_SERVICES': 'Nutzung unserer Dienste',
  'CLUF_USE_OF_OUR_SERVICES_TEXT':
    'Sie erklären sich damit einverstanden, die für die Ihnen bereitgestellten Dienste geltenden Regeln einzuhalten und diese nicht unangemessen zu verwenden. Insbesondere dürfen Sie unsere Dienste nicht stören oder versuchen, durch Verwendung eines anderen Dienstes Zugang zu unserer Website oder unseren Diensten zu erhalten, die wir Ihnen zur Verfügung stellen. Sie dürfen unsere Dienste nur in Übereinstimmung mit den geltenden Bestimmungen nutzen. Wir sind berechtigt, den Zugriff auf unsere Website und die Bereitstellung unserer Dienste auszusetzen oder zu beenden, wenn Sie die Bedingungen oder geltenden Bestimmungen nicht einhalten. Sie dürfen einen Teil oder die gesamte Website, die Dienste oder die Software, die unter diese Richtlinie fallen, nicht kopieren, modifizieren, verbreiten, verkaufen oder vermieten. Den Quellcode einer solchen Software zu extrahieren ist nicht erlaubt, es sei denn, das Recht zur Dekompilierung ist gesetzlich zulässig und liegt innerhalb der in diesem Gesetz festgelegten Grenzen, oder Sie haben vorher unsere schriftliche Genehmigung erhalten. Die Nutzung unserer Website und unserer Dienste gewährt Ihnen keinerlei Nutzungsrechte oder Rechte an geistigem Eigentum an den Inhalten, auf die Sie zugreifen oder die aus unseren Inhalten erstellt wurden, sofern im Vertrag nichts anderes bestimmt ist. Der Inhalt enthält alle Informationen, Marken, Kreationen, die durch das Recht des intellektuellen Eigentums geschützt sind oder nicht, wie Fotos, Musik, Texte, Videos, Software, Diagramme, Verwaltungstool usw. Auf unserer Website und unseren Diensten werden möglicherweise Inhalte angezeigt, die nicht uns gehören und die möglicherweise von unseren Kunden bereitgestellt wurden. Dieser Inhalt liegt in der alleinigen Verantwortung des Kunden oder der Stelle, die ihn zur Verfügung gestellt hat. Möglicherweise müssen wir den Inhalt überprüfen, um sicherzustellen, dass er den geltenden Bestimmungen oder unseren Nutzungsbedingungen entspricht, und er kann bei Nichteinhaltung entfernt werden. Insbesondere können wir die Konten von Benutzern deaktivieren, die Urheberrechte und verwandte Rechte verletzt haben. Die Tatsache, dass wir uns das Recht auf Überprüfung und Löschung vorbehalten, bedeutet jedoch nicht, dass wir den Inhalt unbedingt prüfen.',

  'CLUF_PROTECTION_OF_PRIVACY': 'Datenschutz',
  'CLUF_PROTECTION_OF_PRIVACY_TEXT':
    'Die MCube-Datenschutzrichtlinie erläutert, wie wir Ihre persönlichen Daten verarbeiten und Ihre Privatsphäre schützen, während Sie unsere Website und unsere Dienste nutzen. Sie stimmen diesen Vertraulichkeitsregeln ausdrücklich zu, bevor Sie unsere Dienste nutzen oder Newsletter abonnieren.',

  'CLUF_CONTENT': 'Inhalte',
  'CLUF_CONTENT_TEXT':
    'Mit einigen unserer Dienste können Sie Inhalte importieren, übermitteln, speichern, senden oder empfangen. Sie behalten alle Ihre intellektuellen Eigentumsrechte an diesen Inhalten. Sie garantieren MCube, dass die auf der Website veröffentlichten Inhalte legal und deren Inhalt korrekte Informationen und insbesondere Ihre Geschäftsdaten sind. Wenn Sie Inhalte über unsere Services importieren, übermitteln, speichern, senden oder empfangen, erteilen Sie MCube für die Dauer Ihres Vertrags weltweit eine Lizenz für Nutzung, Hosting, Speicherung, Reproduktion und Änderung, Erstellung abgeleiteter Werke (Übersetzungen, Anpassungen oder sonstige Änderungen, die dazu dienen, die Funktionsweise Ihrer Inhalte durch unsere Dienste zu verbessern), Kommunikation, Veröffentlichung, öffentliche Vertretung, öffentliche Anzeige oder öffentliche Verbreitung solcher Inhalte. Die Verwendung von für Sie von MCube erstellten und vorgenommenen Inhalten unterliegt den Bestimmungen, Bedingungen und Beschränkungen des von Ihnen abgeschlossenen Vertrags. MCube übernimmt keine Verantwortung für die Verwendung dieser Informationen außerhalb der Bestimmungen vom Vertrag. ',

  'CLUF_AMENDMENT_AND_TERMINATION': 'Änderung und Beendigung unserer Dienste',
  'CLUF_AMENDMENT_AND_TERMINATION_TEXT':
    'MCube ändert und verbessert seine Dienste regelmäßig. MCube kann Funktionen hinzufügen oder entfernen, aber auch die Dienste ganz oder teilweise aussetzen, einstellen oder der Nutzung der Dienste jederzeit neue Grenzen setzen.',

  'CLUF_WARRANTIES_AND_DISCLAIMERS': 'Gewährleistungen und Haftungsausschlüsse',
  'CLUF_WARRANTIES_AND_DISCLAIMERS_TEXT':
    'Die von MCube bereitgestellte Website und die von MCube bereitgestellten Dienste unterliegen einer Mitteilungspflicht. Es besteht ein Gewährleistungsausschluss innerhalb der gesetzlich zulässigen Grenzen. MCube übernimmt keine Gewährleistung im Rahmen dieser Nutzungsbedingungen in Bezug auf den Inhalt der Website und Services, ihre spezifischen Merkmale, Zuverlässigkeit, Verfügbarkeit oder ihre Eignung für Ihre Bedürfnisse, und MCube übernimmt keine Haftung für die mögliche Inkompatibilität der Tools und Software, die Sie für den Zugriff auf unsere Services verwenden, auch nicht für entgangenem Gewinn, entgangene Einnahmen oder Daten oder für indirekte, besondere, aufeinanderfolgende Folgeschäden, beispielhafte oder strafbare Schäden, die Sie erleiden könnten. Die Haftung von MCube ist auf den vernünftigerweise vorhersehbaren Verlust oder die vorhersehbaren Schäden sowie auf die Beträge beschränkt, die für die Nutzung der Dienste gezahlt werden. ',

  'CLUF_ACCESS_RIGHTS': 'Zugriffsrechte zu unseren Dienstleistungen ',
  'CLUF_ACCESS_RIGHTS_TEXT':
    'Wenn Sie unsere Dienste im Namen eines Unternehmens nutzen, handeln Sie im Namen dieses Unternehmens und haben bereits die erforderlichen Berechtigungen gemäß dessen Betriebsregeln erhalten, um als Administrator und / oder Benutzer der Schnittstelle und interaktiven Dienste zu fungieren, die Ihnen zur Verfügung gestellt werden. ',

  'CLUF_CHANGES_TO_THE_TERMS': 'Änderungen der Nutzungsbedingungen',
  'CLUF_CHANGES_TO_THE_TERMS_TEXT':
    'Änderungen der Nutzungsbedingungen gelten nicht rückwirkend und treten spätestens acht (8) Tage nach ihrer Veröffentlichung in Kraft. Die Änderungen, die sich auf eine neue Funktion in einem Service beziehen, oder Änderungen, die aus rechtlichen Gründen vorgenommen wurden, gelten ab sofort. Wenn Sie die Änderungen dieser Nutzungsbedingungen nicht akzeptieren, müssen Sie die Nutzung unserer Dienste einstellen. ',

  'CLUF_APPLICABLE_LAW': 'Anwendbares Recht',
  'CLUF_APPLICABLE_LAW_TEXT':
    'Im Falle eines Widerspruchs zwischen diesen Nutzungsbedingungen und / oder zusätzlichen Bedingungen und / oder dem Vertrag ersetzt der Vertrag die zusätzlichen Bedingungen. Wenn Sie diese Nutzungsbedingungen nicht einhalten und wir sie nicht unverzüglich annehmen, wenn diesbezüglich Maßnahmen ergriffen werden, bedeutet dies nicht, dass wir unsere Rechte verlagern. Sollte sich herausstellen, dass eine Klausel / Bedingung nicht anwendbar ist, bleiben die übrigen Bestimmungen dieser Nutzungsbedingungen davon unberührt. Diese Nutzungsbedingungen unterliegen dem belgischen Recht und den französischsprachigen Gerichten von Brüssel im Rahmen der gesetzlichen Bestimmungen, insbesondere in Bezug auf Nutzer, die möglicherweise keine juristischen Personen sind. ',

  'SCOPE_OF_APPLICATION': 'Geltungsbereich',
  'SCOPE_OF_APPLICATION_TEXT':
    'Während Sie unsere Website und unsere Dienste nutzen, sammelt, verarbeitet und überträgt MCube Ihre personenbezogenen Daten gemäß den geltenden Bestimmungen (Allgemeine Datenschutzbestimmungen für personenbezogene Daten und belgisches nationales Recht). Neue Technologien sind für unser Geschäft und die von uns angebotenen Dienstleistungen von wesentlicher Bedeutung, beispielsweise die Erstellung von Inhalten, die Verfügbarkeit von Tools zur Erstellung von Multimediainhalten sowie die Programmierung von Nachrichten und audiovisuellen Kampagnen, Ihre Privatsphäre während der Nutzung der Website und / oder der Dienste und wie Sie Ihre diesbezüglichen Rechte als Benutzer und / oder Kunde schützen. Es wird festgelegt, wie Ihre persönliche Einwilligung erhoben wird und zu welchen Zwecken die Verarbeitung erfolgt. Durchsuchen Sie die Website und / oder nutzen Sie die Dienste, um zu bestätigen, dass Sie diese ohne Einschränkung gelesen, bestätigt und akzeptiert haben, vorbehaltlich dieser Datenschutzerklärung. Zukünftige Anpassungen können nicht ausgeschlossen werden. Vorgenommene Anpassungen werden auf dieser Seite veröffentlicht. Wir empfehlen Ihnen daher, die genannten Datenschutzbestimmungen regelmäßig zu lesen. ',

  'CONTROLLER': 'Controller',
  'CONTROLLER_TEXT':
    'Der Controller ist Storever Belgium SPRL, Boulevard International 55 in 1070 Anderlecht, Belgien, registriert im Unternehmensregister unter der Nummer 0666834913; Kontaktperson: support@mcubedigital.com;',

  'DATA_WE_COLLECT': 'Daten, die wir sammeln',

  'STANDARD_DATA': 'Standarddaten',
  'STANDARD_DATA_TEXT':
    'Jedes Mal, wenn die Website besucht wird oder die Dienste genutzt werden, einschließlich beim Erstellen eines Kontos, werden die folgenden persönlichen Daten erfasst:',

  'YOUR_IP_ADDRESS': 'Ihre IP-Adresse',
  'THE_DNS_ADDRESS': 'Die DNS-Adresse',
  'THE_DATE_AND_DURATION': 'Datum und Dauer Ihres Besuchs auf der Website',
  'THE_PAGES_YOU_VISIT': 'Die Seiten, die Sie auf der Website besuchen',
  'YOUR_BROWSER': 'Ihr Browser',
  'URL_REFERRER': 'URL Referrer',

  'PERSONAL_CONTACT_DATA': 'Persönliche Kontaktdaten',
  'PERSONAL_CONTACT_DATA_TEXT':
    'Um die auf unserer Website angebotenen Dienste zu nutzen und Inhalte und Programme verfügbar zu machen, erstellen oder finalisieren Sie ein Benutzerkonto (im Folgenden " Benutzerkonto "), unter dem Sie folgende Daten angeben:',

  'YOUR_FIRST_AND_LAST_NAMES': 'Ihr Vor- und Nachname, Ihr Geschlecht,',
  'YOUR_OCCUPATION': 'Ihre Tätigkeit im Unternehmen, falls zutreffend;',
  'YOUR_EMAIL_ADDRESS': 'Ihre E-Mail-Adresse',
  'YOUR_WORK_PHONE_NUMBER': 'Ihre geschäftliche Telefonnummer (Mobil- und / oder Festnetznummer), Faxnummer, Skype, optional,',
  'YOUR_TIME_ZONE': 'Ihre Zeitzone, optional.',

  'THESE_DATA_ARE_ALSO_COLLECTED':
    'Diese Daten werden ebenfalls gesammelt und verarbeitet, um die Player zu liefern und Sie gezielt zu unterstützen. Wir verwenden diese Informationen auch, um zu prüfen, ob Dritte Ihre E-Mail-Adresse verwenden, um Berechtigungen ohne Ihre Zustimmung zu erteilen. Darüber hinaus werden während der gesamten Vertragslaufzeit folgende Daten aufbewahrt: ',

  'PHONE_CALLS': 'Telefonanrufe',
  'MESSAGES_SENT_THROUGH': 'Nachrichten, die über unseren Online-Nachrichtendienst gesendet wurden',

  'NO_SENSITIVE_DATA_SHALL_BE_COLLECTED': 'Es werden keine sensiblen Daten erfasst.',

  'NEWSLETTER': 'Newsletter',
  'NEWSLETTER_TEXT':
    'Wir können Ihnen kommerzielle E-Mails (" Newsletter") senden, wenn Sie uns dazu Ihre Zustimmung erteilt haben. In unseren Newslettern finden Sie Informationen zu unseren bestehenden Diensten sowie zu unseren neuen Diensten. Sie können den Newsletter abbestellen, indem Sie auf den Link zum Abbestellen klicken, der unserem Newsletter hinzugefügt wurde. Bitte beachten Sie: Wenn Sie uns auffordern, Ihnen keine Newsletter mehr zu senden, werden Ihre persönlichen Daten und Ihre Anfrage aufgezeichnet, um sicherzustellen, dass Sie unsere Newsletter nicht erhalten. ',

  'CONNECTION_TO_THE_SERVICE': 'Verbindung zum Dienst und zu Inhalten von Dritten',
  'CONNECTION_TO_THE_SERVICE_TEXT':
    'Manchmal können Inhalte von Drittanbietern - beispielsweise Videos von YouTube, Karten von Google Maps, RSS - Datenbanken oder Grafiken von anderen Websites - in das Online-Angebot einbezogen werden. Dies bedeutet auch, dass der Inhaltseigentümer (in Verweis auf den fremden Eigentümer) die IP-Adresse des Nutzers sammelt, was sinnvoll ist, da ohne eine IP-Adresse der Inhalt nicht an den jeweiligen Nutzer verschickt werden kann und die IP-Adresse auch für die Darstellung der Inhalte benötigt wird, um die Inhalte, die Eigentümer direkt über die IP-Adresse versenden, zu verwenden. Darüber hinaus haben wir keinerlei Einfluss darauf, wie die IP-Adresse von Dritten gespeichert wird, z.B. für statistische Auswertungen. Wenn uns solche Praktiken bekannt werden, werden wir den Kunden darüber informieren. ',

  'COOKIES': 'Cookies',
  'COOKIES_TEXT':
    'Cookies sind Textdateien, mit denen wir Informationen auf Ihrem Computer speichern können. Informationen zu Cookies können verwendet werden, um Konfigurationen für jeden Besuch zu verwalten, bestimmte Site-Funktionen bereitzustellen und mehr darüber zu erfahren, wie Besucher unsere Site nutzen (Benutzernamen, Sprache und andere Anzeigeeinstellungen). Diese Informationen helfen uns, unsere Website zu verbessern und Ihnen die bestmögliche Benutzererfahrung zu bieten. Alle gängigen Webbrowser-Softwareanwendungen bieten Optionen zum Blockieren und Entfernen von Cookies von Ihrem Computer. Das Löschen von Cookies kann Ihre Benutzererfahrung beeinträchtigen oder die Nutzung bestimmter Funktionen unserer Website verhindern. Analytische Cookies ermöglichen es uns, anonyme statistische Informationen über die Anzahl der Besuche unserer Website zu erhalten, um diese zu optimieren und etwaige Fehlfunktionen zu erkennen. Wenn Sie nicht zulassen möchten, dass unsere Websites und Dienste Cookies in Ihrem Browser gespeichert werden, um die Zielgruppe der Website zu messen, können Sie auf den folgenden Link klicken, um weitere Informationen zu erhalten: Google Analytics-Cookies https://tools.google.com/dlpage/gaoptout Wir verwenden die Doubleclick-Plattform, um die Anzeigenschaltung auf unseren Websites zu verwalten. Sie können auf den folgenden Link klicken, um Cookies von Doubleclick aus zu verwalten. https://www.google.com/settings/u/0/ads/authenticated ',

  'PURPOSE_OF_YOUR_DATA_PROCESSING': 'Zweck Ihrer Datenverarbeitung',
  'WE_ONLY_COLLECT_AND_PROCESS': 'Wir erheben und verarbeiten Ihre Daten nur zu den ausdrücklich angegebenen Zwecken:',

  'YOUR_CONSENT_TO_RECEIVE_OUR_NEWSLETTERS': 'Ihre Zustimmung zum Empfang unserer Newsletter',
  'THE_USE_OF_OUR_SITE_AND_SERVICES': 'Nutzung unserer Website und unserer Dienste zur Verwaltung Ihrer Softwareanwendungen',
  'the_implementation_of_the_service': 'Die Implementierung des Servicevertrags, der uns an Ihr Unternehmen bindet.',

  'HOW_LONG_YOUR_DATA_WILL_BE_STORED': 'Wie lange werden Ihre Daten gespeichert?',
  'HOW_LONG_YOUR_DATA_WILL_BE_STORED_TEXT':
    'Wir bewahren Ihre Daten nur für die Zeit auf, die für die Bereitstellung der abonnierten Dienste erforderlich ist. Über diesen Zeitraum hinaus werden sie nur zu statistischen Zwecken oder zur Erfüllung gesetzlicher Anforderungen gespeichert und für keine anderen Zwecke genutzt.',

  'TRANSFER_OF_YOUR_DATA': 'Übertragung Ihrer Daten',
  'TRANSFER_OF_YOUR_DATA_TEXT':
    'Wir speichern Ihre personenbezogenen Daten in der Europäischen Union. Sie können jedoch nur in geringem Umfang an Subunternehmer oder Geschäftspartner in anderen Ländern weitergegeben werden. Bei einer solchen Weitergabe stellen wir sicher, dass der Prozess den Anforderungen entspricht. Diese Datenschutzrichtlinie ist in den Standardvertragsklauseln der Europäischen Kommission geregelt, die ein angemessenes Schutzniveau für personenbezogene Daten und die Grundrechte des Einzelnen gewährleisten. ',

  'SICHERHEIT': 'Sicherheit',
  'SECURITY_TEXT':
    'Wir verwenden technische Maßnahmen wie die Verwendung von Passwörtern oder Verschlüsselung, um Ihre Daten sowie die Systeme, auf denen sie gespeichert sind, zu schützen. Wir führen auch betriebliche Maßnahmen zum Datenschutz durch. Wir stellen sicher, dass diese Sicherheitsmaßnahmen regelmäßig aktualisiert werden und stützen uns auf die Sicherheitsstandards der Branche, um über die besten Praktiken informiert zu bleiben. Wir stellen die gleichen Sicherheitsanforderungen in Bezug auf unsere vertraglich verpflichteten Subunternehmer und Partner und stellen sicher, alle technischen und organisatorischen Maßnahmen zu treffen, die erforderlich sind, um personenbezogene Daten vor unbeabsichtigter oder unbefugter Zerstörung, unbeabsichtigtem Verlust sowie vor Veränderung, Zugriff und sonstiger unbefugter Verarbeitung personenbezogener Daten zu schützen. ',

  'RIGHTS_OF_ACCESS_AND_RECTIFICATION': 'Rechte auf Zugriff und Berichtigung',
  'RECHTE_OF_ACCESS_AND_RECTIFICATION_TEXT':
    'Sie können Kopien aller in unserem Besitz befindlichen personenbezogenen Daten ansehen und um Änderung, Berichtigung oder Löschung Ihrer personenbezogenen Daten bitten. Sie können die Verarbeitung Ihrer Daten auch einschränken oder ablehnen. Sie können auf der Site eine Verbindung herstellen, um die darin enthaltenen Informationen zu aktualisieren. Wenn Sie uns Ihre Einwilligung erteilt haben, damit wir Ihre Daten verwenden können, um Ihnen beispielsweise geschäftliche Anfragen zu senden, können Sie Ihre Einwilligung dank des Hyperlinks, der im Hauptteil des Newsletters eingefügt ist, sofort widerrufen. Wir können uns jedoch jederzeit auf die von Ihnen erteilte Einwilligung stützen, die als Rechtsgrundlage für die Verarbeitung von Daten dient, die vor dem Widerruf Ihrer Einwilligung vorgenommen wurden. Um Einwände zu erheben oder von Ihren Rechten Gebrauch zu machen, können Sie sich unter den im Abschnitt "Ansprüche" genannten Bedingungen an uns wenden. Wenn Sie mit uns Kontakt aufnehmen, werden wir Ihnen innerhalb von zwei Monaten antworten, sobald wir dazu in der Lage sind. Wenn Ihre Anfrage komplexer ist, kann unsere Antwortzeit länger sein; wir werden uns jedoch innerhalb von maximal zwei Monaten bei Ihnen melden. Die meisten Anfragen werden kostenlos bearbeitet. Wir können Sie jedoch auffordern, angemessene Verwaltungsgebühren zu zahlen, zum Beispiel, wenn Sie eine große Datenmenge anfordern. Wir können Sie auch bitten, Ihre Identität zu bestätigen, bevor wir Ihnen Informationen zur Verfügung stellen können. ',

  'FORDERUNGEN': 'Ansprüche',
  'CLAIMS_TEXT':
    'Wenn Sie Beschwerden bezüglich der Verarbeitung Ihrer personenbezogenen Daten durch MCube haben, schicken Sie bitte eine E-Mail an support@mcubedigital.com oder schreiben Sie uns an die folgende Adresse: Data Protection, SPRL Storever Belgium, Boulevard International 55 in 1070 Anderlecht, Belgien. Bitte beachten Sie, dass Sie das Recht haben, eine Beschwerde bei einer Aufsichtsbehörde zum Schutz personenbezogener Daten im Land einzureichen, in dem Sie leben oder arbeiten, oder in dem Sie der Ansicht sind, dass ein Verstoß gegen die Datenschutzbestimmungen vorliegt. Kunden in Belgien können die Datenschutzbehörde unter der Rufnummer + 32 (0) 2 274 48 00 oder über das Online-Kontaktformular auf der Website der Behörde kontaktieren www.autoriteprotectiondonnees.be. ',
  'ERROR_USER_EMAIL_NOT_UNIQUE': 'Fehler, dass mehrere Benutzer mit dieser Adress-E-Mail existieren, wenden Sie sich bitte an das Entwicklerteam',
  'PLAYER_SUBSCRIPTION': 'Player',
  'TICKET_LIST_FILTER_SUBSCRIPTION': 'Player name',
  'TICKET_INFO_TITLE': 'Ticketinfos',
  'TICKET_CREATED': 'Erstellt',
  'TICKET_CLOSED': 'Abgeschlossen',
  'TICKET_DEVICE_ID': 'Geräte-ID',
  'TICKET_MODEL': 'Geräte-ID',
  'TICKET_STATUS': 'Status',
  'TICKET_STATUS_OPENED': 'GEÖFFNET',
  'TICKET_STATUS_CLOSED': 'ABGESCHLOSSEN',
  'SUBSCRIPTION_INFO': 'Player die info',
  'TODO_INFO': 'Todo info',
  'TODO_TYPE': 'Todo typ',
  'TODO_USER_ASSIGN': 'Benutzerzuweisung',
  'TODO_DESCRIPTION': 'Beschreibung',
  'TODO_ACTION': 'Handlung',
  'TODO_ACTION_DATE': 'Aktionsdatum',
  'TICKET_ADDRESS': 'Die Anschrift',
  'TICKET_CONTACT': 'Kontakt',
  'TICKET_LIST_QUICK_SEARCH': 'Schnellsuche nach player-ID, Beschreibung odertodo ',
  'TICKET_LIST_PAGE_TITLE': 'Portal | Karten',
  'TICKET_DETAILS_PAGE_TITLE': 'Portal | Kartendetails',
  'TICKETS': 'Karten',
  'TICKETS_LIST_TITLE': 'Karten',
  'TICKETS_ISSUE_TYPE': 'Problemtyp',
  'TICKETS_DESCRIPTION': 'Beschreibung',
  'TICKETS_DATE_CREATION': 'Schaffung',
  'TICKETS_DATE_CLOSE': 'Nah dran',
  'TICKETS_IS_CLOSE': 'Status offen',
  'TICKET_ID': 'Ticket ID',
  'MUSIC_PREVIEW_TITLE': 'Music Preview',
  'MUSIC_PREVIEW_LIST_PAGE_TITLE': 'Portal | Music Preview',
  'MUSIC_PREVIEW_LINK_MODAL_PAGE_TITLE': 'Link station and boxes to your client',
  'MUSIC_PREVIEW_IMPORT_STATION_DIALOG': 'Stations',
  'MUSIC_PREVIEW_DIALOG_STATION_NONE': '(select a station)',
  'MUSIC_PREVIEW_DIALOG_BOXES_NONE': '(select a box or playlist)',
  'MUSIC_PREVIEW_IMPORT_BOXES_DIALOG_PLAYLIST': 'Boxes and playlist',
  'MUSIC_PREVIEW_DIALOG_CONFIRM': 'Save',
  'AUDIO_PLANNINGS_ARTISTS_NAME': 'Artists',
  'MUSIC_PREVIEW_RATING': 'Rating',
  'AUDIO_PLANNINGS_TITLE': 'Title',
  'AUDIO_PLANNINGS_YEAR': 'Year',
  'BOX_PLAYLIST_LOAD_ERROR': 'Box playlist load error',
  'RATTING_SUCCESS': 'Rating update success',
  'STATIONS_LOAD_ERROR': 'Station success',
  'RATTING_ERROR': 'Rating update error',
  'CREATE_BOX_STATION_CLIENT_SUCCESS': 'Create link between client , station and box success',
  'CREATE_BOX_STATION_CLIENT_ERROR': 'Create link between client , station and box error',
  'TRACK_LIST_BAD_REQUEST_ERROR': 'Track list Bad request',
  'TRACK_LIST_LOAD_ERROR': 'Tracks list load error',
  'ROLE_PORTAL_MUSICPREVIEW': 'Kann Musikvorschau anzeigen',
  'MUSIC_PREVIEW_NO_LINK_MSG_1': 'The preview of music is not planned.',
  'MUSIC_PREVIEW_NO_LINK_MSG_2': 'Please ask your producer to plan preview music.',
  'MUSIC_PREVIEW_NO_RULE_MSG_1': 'You don\'t have enough right.',
  'MUSIC_PREVIEW_NO_RULE_MSG_2': 'Please ask your producer to update your right.',
  'ROLE_BO_SETUP': 'Can Setup Player',
  'ROLE_BO_ORDER': 'Can manage Order',
  'ROLE_BO_CANCLOSESITE': 'Can close site',
  'ROLE_BO_SHIPPING_VIEW': 'Can view shipping',
  'ROLE_BO_BILLING_VIEW': 'Can view  billing',
  'ROLE_BO_BILLING_EDIT': 'Can manage billing',
  'ROLE_BO_SHIPPING_EDIT': 'Can manage shipping',
  'ROLE_BO_PLAYERCONFIG_VIEW': 'Can view Player configuration',
  'ROLE_BO_PLAYERCONFIG_EDIT': 'Can manage Player configuration',
  'ROLE_BO_BILLING_CHANGE_CURRENCY': 'Can change the currency of a contract',
  'ROLE_BO_ORDERCANCEL_PICKED': 'Can cancel an order even if player is picked',
  'ROLE_BO_MANAGER_PLAYER': 'Can manage a player from a subscription',
  'ROLE_BO_BILLING_INVOICES_VIEW': 'Can view invoices',
  'ROLE_BO_BILLING_INVOICES_CREATE': 'Can create invoices',
  'ROLE_BO_BILLING_EXECUTE': 'Can launch billing calculation',
  'ROLE_BO_BILLING_SALES_DASHBOARD_EDIT': 'Can edit content and target in Sales dashboard',
  'ROLE_BO_REPORTING_SUPPORT': 'Can view report support stats',
  'REASON_DONT_LIKE_THE_SONG_TITLE': 'Bitte geben Sie an, warum Ihnen dieses Lied nicht gefällt.',
  'REASON_DONT_LIKE_THE_SONG': 'Grund',
  'AUDIO_PLANNINGS_COMMENT': 'Kommentare',
  'SAVE': 'Speichern',
  'PLAYER_EVENT_LOGS_LAST_ERROR': 'Heute gefundene Fehler',
  'PLAYERS_ISSUE_CLIENT_NAME': 'Kunden',
  'PLAYERS_ISSUE_LIST_TITLE': 'Player issues',
  'PLAYERS_ISSUE_LIST_UPDATED': 'Aktualisiert',
  'PLAYERS_ISSUE_LIST_CREATED': 'Letzte Aktualisierung',
  'PLAYERS_ISSUE_LIST_CLOSED': 'Geschlossen',
  'PLAYERS_ISSUE_LIST_TYPE_ISSUE': 'Typ',
  'PLAYERS_ISSUE_LIST_TYPE_DESCRIPTION': 'Beschreibung',
  'PLAYERS_ISSUE_LIST_CLIENT': 'Kunden',
  'PLAYERS_ISSUE_LIST_START_DATE': 'Startdatum',
  'PLAYERS_ISSUE_LIST_END_DATE': 'Endtermin',
  'PLAYERS_ISSUE_FILTER_START_DATE': 'Startdatum',
  'PLAYERS_ISSUE_FILTER_END_DATE': 'Letzte Aktualisierung',
  'PLAYERS_ISSUE_LIST_QUICK_SEARCH': 'Schnellsuche nach Standort und Kunde',
  'PLAYERS_LIST_ISSUE_QUICK_SEARCH': 'Schnelle Suche mit Player',
  'PLAYERS_LIST_FILTER_SUBSCRIPTION': 'Subscription',
  'CREATE_USER_DIALOG_IS_STOREVER': 'Is MCube',
  'ROLE_PORTAL_PLAYERISSUES': 'Kann das Player-Problem anzeigen',
  'ROLE_PORTAL_ADVANCED_USER_MANAGEMENT': 'Kann die erweiterte Benutzerverwaltung anzeigen',
  'PRODUCTION_LINE_BXL': 'Production line Brussels',
  'PRODUCTION_LINE_SHA': 'Production line Shanghai',
  'PRODUCTION_LINE_TRI': 'Production line Trieste',
  'PRODUCTION_LINE_MIL': 'Production line Milano',
  'PRODUCTION_LINE_PAR': 'Production line Paris',
  'PRODUCTION_LINE_EXT': 'External Partners',
  'ROLE_BO_ANOMALIES_MULTIPLEDEFAULT_PLAYER': 'Anzeige von Anomalien mit Multi-Default-Player zulassen',
  'COMMAND_UPDATE': 'Update',
  'COMMAND_REBOOT': 'Reboot',
  'COMMAND_UPGRADE FIRMWARE': 'Upgrade firmware',
  'COMMAND_TAKE SCREENSHOT': 'Take screenshot',
  'PLAYER_SCREENSHOT_REPORTED_AT': 'Reported at',
  'PLAYER_SCREENSHOT_DIMENSION': 'Dimension',
  'PLAYER_SCREENSHOT_SIZE': 'Size',
  'CLIENT_SERVICE_SERVICE': 'Service',
  'CLIENT_SERVICE_MAINTENANCE': 'Maintenance',
  'CLIENT_SERVICE_HOSTING': 'Hosting',
  'PLAYER_SCREENSHOT_FORMAT': 'Format'
}
